import './aaContainer.scss';
import { useEffect, useRef, useState } from 'preact/hooks';
import { Fragment, h } from 'preact';
import { ClassMapConstanst, IdMapConstant, ProjConstants, serviceTabMap, Tabs, coachingConst, DARKTHEME_COLORCODES, storageConst} from '../../../constants/projConsts';
import { AllTabs } from '../../tabs/all-tabs';
import { Assist } from '../../tabs/assist/assist';
import { AgenticCoPilot } from '../../tabs/agentic-CoPilot/agentic-CoPilot';
import { Search } from '../../tabs/search/search';
import { Transcript } from '../../tabs/transcript/transcript';
import { Playbook } from '../../tabs/playbook/playbook';
import { Header } from '../../tabs/header/header';
import { DATA_EVENTS, SDK_EVENTS, EVENTS, INTERNAL_EVENTS, EVENTS_TO_SDK } from '../../../constants/events.cnst';
import { MyBot } from '../../tabs/mybot/mybot';
import { getHTML } from '../domManager';
import KoreGenerateuuidPipe from '../../../utils/koregenerateuuid';
import { RenderAttachmentImageView, RenderInterruptionPopup, RenderListView, RenderMultipleOptionsPopup, RenderSettingsPopup, RenderTerminatePopup } from '../../tabs/atom/dialogPopups';
import { FeebackConst } from '../../../constants/settingsConsts';
import { FeedbackWrapperInsideDialog } from '../../tabs/automation/automation';
import ErrorBoundary from '../../tabs/ErrorBoundary/ErrorBoundary';
import { CustomTab } from '../../tabs/custom-tab/custom';
import { sentimentScore } from '../../tabs/sentimentScore/sentimentScore';
import { OverallFeedbackSection } from '../../tabs/feedback/feedback';

export function NetworkErrorToast(props : any){
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="toast-custom-msg-container aa-network-error-toastr aa-hidden">
            <div className="toast-msg-custom">
            <div className="icon_block">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7.17843 0.502645C3.59639 0.401083 0.604208 3.23702 0.502645 6.81905C0.401083 10.4011 3.23702 13.3972 6.81905 13.4987C10.4011 13.5964 13.3972 10.7644 13.4987 7.17843C13.5107 6.71937 13.4729 6.27055 13.3916 5.83646C13.3204 5.45632 12.8618 5.33602 12.5804 5.60138C12.445 5.72904 12.389 5.91835 12.4205 6.10172C12.4793 6.44341 12.5078 6.7945 12.4987 7.15499C12.4128 10.1862 9.87764 12.5808 6.84639 12.4987C3.81514 12.4128 1.41671 9.87764 1.49874 6.84639C1.58468 3.81514 4.11983 1.41671 7.15108 1.49874C8.00397 1.5256 8.8049 1.74585 9.51665 2.11731C9.72197 2.22446 9.97509 2.20036 10.1432 2.04103C10.3813 1.81533 10.3481 1.42597 10.0589 1.27097C9.19863 0.809842 8.22268 0.531475 7.17843 0.502645ZM12.3523 2.6921C12.157 2.49686 11.8405 2.49686 11.6452 2.6921L5.99874 8.33858L4.49874 6.84639L4.34964 6.69496C4.15628 6.49859 3.83996 6.49736 3.64509 6.69223C3.45032 6.887 3.45143 7.20312 3.64756 7.39651L3.79874 7.54559L5.64519 9.39796C5.84036 9.59376 6.15738 9.59401 6.35286 9.39853L12.3523 3.39913C12.5475 3.20389 12.5475 2.88734 12.3523 2.6921Z" fill="#135423" />
                </svg>
            </div>
            <h1 className="toast-content-info">{languageData?.SERVER_CONNECTION_ERROR}</h1>
            <button className="close-toast-msg aa-network-error-close-btn">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M15 5.2002L5 15.2002M5 5.2002L15 15.2002" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
        </div>
    )
}

export function FeedbackToast(props : any){
    return (
        <div className="toast-custom-msg-container aa-feedback-toastr aa-hidden">
        <div className="toast-msg-custom">
            <div className="icon_block">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7.17843 0.502645C3.59639 0.401083 0.604208 3.23702 0.502645 6.81905C0.401083 10.4011 3.23702 13.3972 6.81905 13.4987C10.4011 13.5964 13.3972 10.7644 13.4987 7.17843C13.5107 6.71937 13.4729 6.27055 13.3916 5.83646C13.3204 5.45632 12.8618 5.33602 12.5804 5.60138C12.445 5.72904 12.389 5.91835 12.4205 6.10172C12.4793 6.44341 12.5078 6.7945 12.4987 7.15499C12.4128 10.1862 9.87764 12.5808 6.84639 12.4987C3.81514 12.4128 1.41671 9.87764 1.49874 6.84639C1.58468 3.81514 4.11983 1.41671 7.15108 1.49874C8.00397 1.5256 8.8049 1.74585 9.51665 2.11731C9.72197 2.22446 9.97509 2.20036 10.1432 2.04103C10.3813 1.81533 10.3481 1.42597 10.0589 1.27097C9.19863 0.809842 8.22268 0.531475 7.17843 0.502645ZM12.3523 2.6921C12.157 2.49686 11.8405 2.49686 11.6452 2.6921L5.99874 8.33858L4.49874 6.84639L4.34964 6.69496C4.15628 6.49859 3.83996 6.49736 3.64509 6.69223C3.45032 6.887 3.45143 7.20312 3.64756 7.39651L3.79874 7.54559L5.64519 9.39796C5.84036 9.59376 6.15738 9.59401 6.35286 9.39853L12.3523 3.39913C12.5475 3.20389 12.5475 2.88734 12.3523 2.6921Z" fill="#135423" />
                </svg>
            </div>
            <h1 className="toast-content-info">{props?.hostInstance?.languagedata?.THANKS_FEEDBACK}</h1>
            <button className="close-toast-msg aa-feedback-close-btn">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M15 5.2002L5 15.2002M5 5.2002L15 15.2002" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
    )
}

export function AALoder(props: any) {
    return (
        <div id="aa-loader-main" className="loader-progress-main">
            <div className="loading-border"></div>
        </div>
    );
}

export function IndividualLoader(props: any) {
    return (
        <div id="aa-loader-individual" className="loader-progress-individual">
            <div className="loading-border"></div>
        </div>
    );
}

export function AAContainer(props: any) {

    const hostInstance = props.hostInstance;
    const rootServiceInstance = hostInstance.rootService;
    const localStorageServiceInstance = hostInstance.localStorageService;
    const languageData = props?.hostInstance?.languagedata;

    const [assistTabActive, setAssistTabActive] = useState(false);
    const [mybotTabActive, setMybotTabActive] = useState(false);
    const [searchTabActive, setSearchTabActive] = useState(false);
    const [transcriptTabActive, setTranscriptTabActive] = useState(false);
    const [playbookTabActive, setplaybookTabActive] = useState(false);
    const [customTabActive, setCustomTabActive] = useState(false);
    const [selectedTheme, setSelectedTheme] = useState('light');
    const [coachingHints, setCoachingHints] = useState<any[]>([]);
    const [coachingNudges, setCoachingNudges] = useState<any[]>([]);
    const [editedSummaryText, setEditedSummaryText] = useState("");
    const [showWidget, setShowWidget] = useState(rootServiceInstance?.aaSettings?.agentAssistWidgetEnabled);

    const timeoutId = useRef<number | undefined>(undefined);
    
    let hints: any = [];
    let nudges: any = [];

    let tabsNTitles:any = rootServiceInstance?.prefsAccessObj?.orderTabs || [
        { type: 'srch', title: 'Search', isEnabled : true },
        { type: 'mB', title: 'My Bot', isEnabled : true },
        { type: 'ast', title: 'Assist', isEnabled : true },
        { type: 'trnspt', title: 'Transcript', isEnabled : true },
        { type : 'cl', title : 'PlayBook', isEnabled : true},
        { type : 'cst', title : 'Custom Tab', isEnabled : false},
        { type : 'mR', title : 'More', isEnabled : true},
        { type : 'ast-agentic', title : 'Agentic CoPilot', isEnabled : true}
    ];
    const connectionDetails = props.connectionDetails;
    const sourceDesktop = 'SomeSource';
    const hideUserBotHistory = false;
    const serTabMap : any = serviceTabMap;
    let selectTab : any = rootServiceInstance?.activeTab || 'ast';
    const classConstants : any = ClassMapConstanst;
    const idMapConstants : any = IdMapConstant;
    const [offsetX, setOffsetX] = useState(0);
    const [offsetY, setOffsetY] = useState(0);

    // Define a mapping of tab types to their components
    const tabComponents: { [key: string]: any } = {
        'srch': Search,
        'mB': MyBot,
        'trnspt': Transcript,
        'cl': Playbook,
        'cst': CustomTab,
        'ast': Assist,
        'ast-agentic': AgenticCoPilot
    };

    const moreOptions: any = [
        {
            className: 'feedback',
            title: languageData?.FEEDBACK_TITLE,
            icon: <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <path d="M4.08333 14.0833V6.75M0.75 8.08333V12.75C0.75 13.4864 1.34695 14.0833 2.08333 14.0833H11.0342C12.0213 14.0833 12.8608 13.3631 13.0109 12.3874L13.7289 7.72078C13.9152 6.50926 12.9779 5.41667 11.7521 5.41667H9.41667C9.04848 5.41667 8.75 5.11819 8.75 4.75V2.39389C8.75 1.486 8.014 0.75 7.10611 0.75C6.88956 0.75 6.69332 0.87753 6.60537 1.07542L4.25929 6.35409C4.15229 6.59484 3.91354 6.75 3.65008 6.75H2.08333C1.34695 6.75 0.75 7.34695 0.75 8.08333Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
            
        }
    ]

    // Define a mapping of tab types to their active states
    const tabActiveStates: { [key: string]: boolean } = {
        'srch': searchTabActive,
        'mB': mybotTabActive,
        'trnspt': transcriptTabActive,
        'cl': playbookTabActive,
        'cst': customTabActive,
        'ast': assistTabActive
    };

    const tabTitles : any = {
        'srch': 'Search',
        'mB': 'My Bot',
        'trnspt': 'Transcript',
        'cl': 'PlayBook',
        'cst': rootServiceInstance?.customTabPrefsObj?.customTablbl || 'Custom Tab',
        'ast': 'Assist',
        'mR' : 'More'
    }

    let chatContainerClass = classConstants.SDK_MAIN_WRAPPER; //left-menu-nav-enable

    if(tabsNTitles?.length > 0 && hostInstance?.dskSettings?.tabs?.length === 0){
        tabsNTitles = hostInstance?.prepareTabs(tabsNTitles, tabTitles);
    }

    if(hostInstance?.dskSettings?.tabs?.length > 0){
        tabsNTitles =  hostInstance?.dskSettings?.tabs;
    }

    rootServiceInstance.tabsNTitles = tabsNTitles;

    useEffect(() => {

        if(!rootServiceInstance.activeTab){
            rootServiceInstance.activeTab =  rootServiceInstance?.prefsAccessObj?.defaultTab || (tabsNTitles?.find((item:any) => item?.default))?.type || tabsNTitles[0]?.type;
        }

        hostInstance.on(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB, (data : any)=> {            
            toggleActiveTab(data.activeTab, data.footerTag);
        });

        updateTabActive(rootServiceInstance.activeTab, false);   

        rootServiceInstance.checkTransferDetailsAndDisableWidget(hostInstance);
        addHeaderTemplate();
        addFooterTemplate();
        addTerminatePopupTemplate();
        addInterruptPopupTemplate();
        addFeedbackToastrTemplate();
        addListViewPopupTemplate();
        addAttachmentViewTemplate(); 
        addSettingsTemplate();
        addSentimentPopupTemplate();
        handleSentimentPopupOutSideClick();
        // addGenerateSummaryAction();

        hostInstance.on(DATA_EVENTS.AGENT_FEEDBACK_RESPONSE, handleFeedbackResponse);

        hostInstance.on('AGENT_COACHING_RESPONSES', handleCoachingEvents);

        hostInstance.on('END_OF_CONVERSATION', endOfConversationEvent);
        hostInstance.on('SET_SUMMARY_POPUP', handleSummaryPopup);

        hostInstance.on('RESOLUTION_COMMENTS_RESPONSE', handleSummaryResolutionComments);
        hostInstance.on('DESTROY_WIDGET', handleDestroyWidget);


        hostInstance.on(INTERNAL_EVENTS.PAUSE_TRANSCRIPT, handlePauseResumeTranscript);
        hostInstance.on(INTERNAL_EVENTS.RESUME_TRANSCRIPT, handlePauseResumeTranscript);

        hostInstance.on(INTERNAL_EVENTS.GENERATE_INTERIM_SUMMARY, handleGenerateSummary);

        return () => {
            destroyContainer();
        }
    },[]);

    useEffect(() => {
        if(assistTabActive){
            rootServiceInstance.handleAssistScroll(hostInstance);
        }
        if(transcriptTabActive){
            rootServiceInstance.scrollBottomTranscript(hostInstance);
        }
    }, [assistTabActive, transcriptTabActive]);

    const handleDestroyWidget = () => {
        setShowWidget(false);
        destroyContainer();
    }

    const destroyContainer = () => {
        clearTimeout(timeoutId.current);
        hostInstance.off(EVENTS_TO_SDK.UPDATE_ACTIVE_TAB);
        hostInstance.off(DATA_EVENTS.AGENT_FEEDBACK_RESPONSE, handleFeedbackResponse);
        hostInstance.off('AGENT_COACHING_RESPONSES', handleCoachingEvents);
        hostInstance.off('END_OF_CONVERSATION', endOfConversationEvent);
        hostInstance.off('SET_SUMMARY_POPUP', handleSummaryPopup);
        hostInstance.off('RESOLUTION_COMMENTS_RESPONSE', handleSummaryResolutionComments);
        hostInstance.off('DESTROY_WIDGET', ()=> setShowWidget(false));
        hostInstance.off(INTERNAL_EVENTS.PAUSE_TRANSCRIPT, handlePauseResumeTranscript);
        hostInstance.off(INTERNAL_EVENTS.RESUME_TRANSCRIPT, handlePauseResumeTranscript);
    }


    const handleGenerateSummary = (e : any) => {        
        if(!rootServiceInstance.generatedSummaries?.length){
            generateSummary({}, true);
        }else{
            hostInstance.setSummaryPopup({ initPopup : false, openToShowPreviousSummary : true});
        }
    }


    const handleCoachingEvents = (response: any) => handleCocahingResponse(response);

    const chooseTheme = () => {
        setSelectedTheme(selectedTheme === 'light' ? 'dark' : 'light');
    };

    const endOfConversationEvent = () => {
        generateSummary({}, false);
    }


    const handleCocahingResponse = (resData: any) => {
        if(rootServiceInstance.aaSettings?.agentAssistWidgetEnabled && rootServiceInstance.aaSettings?.isAgentCoachingEnabled){
            if(resData?.action === 'nudge'){
                handleNudgeData(resData);
            } else if(resData?.action === 'hint') {
                handleHintData(resData);
            }
        }
    }

    const handleNudgeData = (NudgeObject: any) =>{
        let uQ = NudgeObject.actionId;
        nudges.unshift(NudgeObject);
        setCoachingNudges(prevNudges => [NudgeObject, ...prevNudges]);

        const nudgeBanner : any = getHTML(nudgeHTMLEle, NudgeObject, hostInstance);
        const nudgeEle = hostInstance?.chatEle?.getElementsByClassName(ClassMapConstanst.NUDGE_TEMPLATE)[0];
        setTimeout(() => {
             let inx = nudges.findIndex((item: any)=> item.actionId === uQ);
             if(inx >= 0){
                const nudgeElement = hostInstance?.chatEle?.querySelector(`#${uQ}`);
                if (nudgeElement) {
                    nudgeElement.remove();
                    coachingHints.splice(inx, 1);
                    closeNudge(uQ);
                    setCoachingNudges(prevNudges => prevNudges.filter((nudge: any) => nudge.actionId !== uQ));
                } 
             }
        }, 7000);
        hostInstance.eventManager?.addEventListener(`.${ClassMapConstanst.NUDGE_CLOSE}`, 'click', () => {
            closeNudge(uQ);
        }, nudgeBanner);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, nudgeBanner, {event: SDK_EVENTS.NUDGE_TEMPLATE, NudgeObject});
        nudgeEle.append(nudgeBanner);
    }

    const nudgeHTMLEle = (props: any) => {
        let {msgData} = props;        
        return (
            <div class={`nudges-card ${coachingConst.NUDGE_DATA[msgData?.expression]?.className}`} id={`${msgData?.actionId}`}>
                {coachingConst.NUDGE_DATA[msgData?.expression]?.icon && (
                    <div className="icon_block">

                        { msgData?.expression === 'neutral' && <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2.55371 8.35C2.55371 7.7701 3.02381 7.3 3.60371 7.3C4.18361 7.3 4.65371 7.7701 4.65371 8.35V12.55C4.65371 13.1299 4.18361 13.6 3.60371 13.6C3.02381 13.6 2.55371 13.1299 2.55371 12.55V8.35Z" fill="white"/>
                            <path d="M5.35371 8.23334V12.0348C5.35371 12.565 5.65331 13.0498 6.12761 13.287L6.1625 13.3044C6.5513 13.4988 6.98002 13.6 7.4147 13.6H11.206C11.8733 13.6 12.4479 13.129 12.5788 12.4746L13.4188 8.27457C13.5921 7.40826 12.9295 6.6 12.046 6.6H9.55371V3.8C9.55371 3.0268 8.92691 2.4 8.15371 2.4C7.76711 2.4 7.45371 2.7134 7.45371 3.1V3.56667C7.45371 4.1725 7.25721 4.762 6.89371 5.24667L5.91371 6.55334C5.55021 7.038 5.35371 7.6275 5.35371 8.23334Z" fill="white"/>
                        </svg>}

                        { msgData?.expression === 'alert' && <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.71312 3.61289C7.27776 2.60908 8.72302 2.60908 9.28766 3.61289L13.4086 10.9389C13.9624 11.9235 13.2509 13.14 12.1213 13.14H3.87949C2.74988 13.14 2.03841 11.9235 2.59222 10.9389L6.71312 3.61289ZM8.7388 10.9246C8.7388 11.3325 8.40817 11.6631 8.00033 11.6631C7.59248 11.6631 7.26185 11.3325 7.26185 10.9246C7.26185 10.5168 7.59248 10.1862 8.00033 10.1862C8.40817 10.1862 8.7388 10.5168 8.7388 10.9246ZM8.00033 5.01685C7.59248 5.01685 7.26185 5.34748 7.26185 5.75533V7.97075C7.26185 8.37859 7.59248 8.70922 8.00033 8.70922C8.40817 8.70922 8.7388 8.37859 8.7388 7.97075V5.75533C8.7388 5.34748 8.40817 5.01685 8.00033 5.01685Z" fill="white"/>
                        </svg>}

                        { msgData?.expression === 'critical' && <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.29961 3.1C7.29961 2.7134 7.61301 2.4 7.99961 2.4C8.38621 2.4 8.69961 2.7134 8.69961 3.1V6.95C8.69961 7.1433 8.85631 7.3 9.04961 7.3C9.24291 7.3 9.39961 7.1433 9.39961 6.95V3.8C9.39961 3.4134 9.71301 3.1 10.0996 3.1C10.4862 3.1 10.7996 3.4134 10.7996 3.8V6.95C10.7996 7.1433 10.9563 7.3 11.1496 7.3C11.3429 7.3 11.4996 7.1433 11.4996 6.95V5.2C11.4996 4.8134 11.813 4.5 12.1996 4.5C12.5862 4.5 12.8996 4.8134 12.8996 5.2V8.7C12.8996 11.4062 10.7058 13.6 7.99961 13.6C5.29341 13.6 3.09961 11.4062 3.09961 8.7V7.3C3.09961 6.9134 3.41301 6.6 3.79961 6.6C4.18621 6.6 4.49961 6.9134 4.49961 7.3V9.05C4.49961 9.2433 4.65631 9.4 4.84961 9.4C5.04291 9.4 5.19961 9.2433 5.19961 9.05V3.8C5.19961 3.4134 5.51301 3.1 5.89961 3.1C6.28621 3.1 6.59961 3.4134 6.59961 3.8V6.95C6.59961 7.1433 6.75631 7.3 6.94961 7.3C7.14291 7.3 7.29961 7.1433 7.29961 6.95V3.1Z" fill="white"/>
                        </svg>}

                        { msgData?.expression === 'positive' && <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M5.76708 0.5C5.40707 0.5 5.08084 0.712015 4.93462 1.04099L3.25425 4.82184C3.21348 4.91357 3.19219 4.96087 3.17474 4.99418L3.17319 4.99711L3.16988 4.99734C3.13236 4.99976 3.08048 5 2.9801 5L2.58073 5C2.31715 4.99999 2.08977 4.99998 1.90249 5.01528C1.70481 5.03144 1.50821 5.06709 1.31902 5.16349C1.03677 5.3073 0.807302 5.53677 0.663492 5.81901C0.567095 6.0082 0.531437 6.20481 0.515286 6.40249C0.499985 6.58977 0.499992 6.81714 0.5 7.08071V9.41927C0.499992 9.68284 0.499985 9.91023 0.515286 10.0975C0.531437 10.2952 0.567095 10.4918 0.663492 10.681C0.807302 10.9632 1.03677 11.1927 1.31902 11.3365C1.50821 11.4329 1.70481 11.4686 1.90249 11.4847C2.08977 11.5 2.31715 11.5 2.58072 11.5C2.81228 11.5 3 11.3123 3 11.0807L3 7C3 6.72386 3.22386 6.5 3.5 6.5C3.77614 6.5 4 6.72386 4 7L4 10.7C4 10.98 4 11.12 4.0545 11.227C4.10243 11.3211 4.17892 11.3976 4.27301 11.4455C4.37996 11.5 4.51997 11.5 4.8 11.5H7.9598C8.30918 11.5 8.59925 11.5 8.83792 11.4818C9.08711 11.4629 9.31681 11.4222 9.53857 11.3217C9.88536 11.1646 10.1801 10.9117 10.3881 10.5929C10.5212 10.3889 10.5963 10.1681 10.6529 9.9247C10.7072 9.69158 10.7513 9.40489 10.8044 9.05958L11.0722 7.31883C11.1426 6.86136 11.2003 6.4863 11.2207 6.18021C11.2418 5.86439 11.228 5.56971 11.1203 5.28725C10.9548 4.85354 10.6437 4.49087 10.2402 4.26142C9.9774 4.11199 9.68824 4.05357 9.37289 4.02636C9.06724 3.99999 8.68779 3.99999 8.22491 4H7.8C7.65174 4 7.57061 3.99961 7.51232 3.99485L7.50573 3.99428L7.50515 3.98768C7.50039 3.92939 7.5 3.84826 7.5 3.7V2.23292C7.5 1.27585 6.72415 0.5 5.76708 0.5Z" fill="#039855"/>
                        </svg>}
                    </div>
                )}
                <p>{msgData?.message?.title}</p>
                <button className="close-nudge aa-close-nudge" aria-label="button">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4 12L12 4M4 4L12 12" stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            </div>

        )
    }
    
    const closeNudge = (uQ: any) => {
        let inx = nudges.findIndex((item: any)=> item.actionId === uQ);
        if(inx >= 0){
            const nudgeElement = hostInstance?.chatEle?.querySelector(`#${uQ}`);
            if (nudgeElement) {
                nudgeElement.remove();
                nudges.splice(inx, 1);
                setCoachingNudges(prevNudges => prevNudges.filter((nudge: any) => nudge.actionId !== uQ));
            }
        }
    }

    const handleHintData = (hintObject: any) => {
        let uQ = hintObject.actionId;
        hints.unshift(hintObject);
        setCoachingHints(prevHints => [hintObject, ...prevHints]);
        // this.hintScrollBottom(true);
        const HintBanner = getHTML(hintHTMLEle, hintObject, hostInstance);
        const hintEle = hostInstance?.chatEle?.getElementsByClassName(ClassMapConstanst.HINT_TEMPLATE)[0];
        if(hintObject?.message?.postAction !== 'doesnot_auto_close'){
            setTimeout(() => {
                let inx = hints.findIndex((item: any)=> item.actionId === uQ);
                if(inx >= 0){
                    const hintElement = hostInstance?.chatEle?.querySelector(`#${uQ}`);
                    if (hintElement) {
                        hintElement.remove();
                        hints.splice(inx, 1);
                        setCoachingHints(prevHints => prevHints.filter((hints: any) => hints.actionId !== uQ));
                    }
                }
            }, (hintObject.message?.time < 900 ? hintObject.message?.time : 900) * 1000);
        }
        hostInstance.eventManager?.addEventListener(`.${ClassMapConstanst.HINT_CLOSE}`, 'click', () => {
            closeHint(uQ);
        }, HintBanner);

        hostInstance.eventManager?.addEventListener(`.${ClassMapConstanst.ACKTEXT_CLOSE}`, 'click', () => {
            hintAckPressed(hintObject)
            closeHint(uQ);
        }, HintBanner);

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, HintBanner, {event: SDK_EVENTS.HINT_TEMPLATE, hintObject});
        hintEle.append(HintBanner);
    }

    const hintHTMLEle = (props: any) => {
        const {msgData} = props;
        return (
            <div className={`hint-card ${coachingConst?.HINT_DATA[msgData?.expression]?.className}`} style={{ border: coachingConst?.HINT_DATA[msgData?.expression]?.color }} id={`${msgData.actionId}`}>
                <div className="top-card-info">
                    {coachingConst?.HINT_DATA[msgData?.expression]?.icon && (
                        <div className="icon_block">

                            { msgData?.expression === 'positive' && <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M5.76708 0.5C5.40707 0.5 5.08084 0.712015 4.93462 1.04099L3.25425 4.82184C3.21348 4.91357 3.19219 4.96087 3.17474 4.99418L3.17319 4.99711L3.16988 4.99734C3.13236 4.99976 3.08048 5 2.9801 5L2.58073 5C2.31715 4.99999 2.08977 4.99998 1.90249 5.01528C1.70481 5.03144 1.50821 5.06709 1.31902 5.16349C1.03677 5.3073 0.807302 5.53677 0.663492 5.81901C0.567095 6.0082 0.531437 6.20481 0.515286 6.40249C0.499985 6.58977 0.499992 6.81714 0.5 7.08071V9.41927C0.499992 9.68284 0.499985 9.91023 0.515286 10.0975C0.531437 10.2952 0.567095 10.4918 0.663492 10.681C0.807302 10.9632 1.03677 11.1927 1.31902 11.3365C1.50821 11.4329 1.70481 11.4686 1.90249 11.4847C2.08977 11.5 2.31715 11.5 2.58072 11.5C2.81228 11.5 3 11.3123 3 11.0807L3 7C3 6.72386 3.22386 6.5 3.5 6.5C3.77614 6.5 4 6.72386 4 7L4 10.7C4 10.98 4 11.12 4.0545 11.227C4.10243 11.3211 4.17892 11.3976 4.27301 11.4455C4.37996 11.5 4.51997 11.5 4.8 11.5H7.9598C8.30918 11.5 8.59925 11.5 8.83792 11.4818C9.08711 11.4629 9.31681 11.4222 9.53857 11.3217C9.88536 11.1646 10.1801 10.9117 10.3881 10.5929C10.5212 10.3889 10.5963 10.1681 10.6529 9.9247C10.7072 9.69158 10.7513 9.40489 10.8044 9.05958L11.0722 7.31883C11.1426 6.86136 11.2003 6.4863 11.2207 6.18021C11.2418 5.86439 11.228 5.56971 11.1203 5.28725C10.9548 4.85354 10.6437 4.49087 10.2402 4.26142C9.9774 4.11199 9.68824 4.05357 9.37289 4.02636C9.06724 3.99999 8.68779 3.99999 8.22491 4H7.8C7.65174 4 7.57061 3.99961 7.51232 3.99485L7.50573 3.99428L7.50515 3.98768C7.50039 3.92939 7.5 3.84826 7.5 3.7V2.23292C7.5 1.27585 6.72415 0.5 5.76708 0.5Z" fill="#039855"/>
                            </svg>}

                            { msgData?.expression === 'neutral' && <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2008 6.00005C10.2008 8.31964 8.32038 10.2 6.00078 10.2C3.68119 10.2 1.80078 8.31964 1.80078 6.00005C1.80078 3.68045 3.68119 1.80005 6.00078 1.80005C8.32038 1.80005 10.2008 3.68045 10.2008 6.00005ZM6.52578 8.10005C6.52578 8.39 6.29073 8.62505 6.00078 8.62505C5.71083 8.62505 5.47578 8.39 5.47578 8.10005C5.47578 7.8101 5.71083 7.57505 6.00078 7.57505C6.29073 7.57505 6.52578 7.8101 6.52578 8.10005ZM6.00078 3.37505C5.71083 3.37505 5.47578 3.6101 5.47578 3.90005V6.00005C5.47578 6.29 5.71083 6.52505 6.00078 6.52505C6.29073 6.52505 6.52578 6.29 6.52578 6.00005V3.90005C6.52578 3.6101 6.29073 3.37505 6.00078 3.37505Z" fill="#667085"/>
                            </svg>}

                            { msgData?.expression === 'alert' && <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.40714 0.834185C6.14848 0.719172 5.8532 0.719172 5.59454 0.834185C5.39478 0.923011 5.26501 1.07947 5.17471 1.20696C5.08593 1.3323 4.99087 1.49651 4.88634 1.67711L0.75276 8.81693C0.647804 8.99818 0.552428 9.16289 0.487757 9.30268C0.422033 9.44475 0.35073 9.63572 0.373455 9.85369C0.40286 10.1357 0.550631 10.392 0.779988 10.5588C0.957236 10.6877 1.15823 10.7217 1.31411 10.736C1.46749 10.75 1.65782 10.75 1.86726 10.75H10.1344C10.3438 10.75 10.5342 10.75 10.6876 10.736C10.8434 10.7217 11.0444 10.6877 11.2217 10.5588C11.451 10.392 11.5988 10.1357 11.6282 9.85369C11.651 9.63572 11.5796 9.44475 11.5139 9.30268C11.4493 9.1629 11.3539 8.9982 11.2489 8.81697L7.11533 1.67709C7.0108 1.49651 6.91575 1.3323 6.82697 1.20696C6.73667 1.07947 6.6069 0.923011 6.40714 0.834185ZM6.50085 4.5C6.50085 4.22386 6.277 4 6.00085 4C5.72471 4 5.50085 4.22386 5.50085 4.5V6.5C5.50085 6.77614 5.72471 7 6.00085 7C6.277 7 6.50085 6.77614 6.50085 6.5V4.5ZM6.00085 8C5.72471 8 5.50085 8.22386 5.50085 8.5C5.50085 8.77614 5.72471 9 6.00085 9H6.00585C6.282 9 6.50585 8.77614 6.50585 8.5C6.50585 8.22386 6.282 8 6.00585 8H6.00085Z" fill="#F79009"/>
                            </svg>}

                            { msgData?.expression === 'critical' && <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M3.45 5.72222V7.11111M3.45 5.72222V2.38889C3.45 1.92865 3.83056 1.55556 4.3 1.55556C4.76944 1.55556 5.15 1.92865 5.15 2.38889M3.45 5.72222C3.45 5.26198 3.06944 4.88889 2.6 4.88889C2.13056 4.88889 1.75 5.26198 1.75 5.72222V6.83333C1.75 9.13452 3.65279 11 6 11C8.34721 11 10.25 9.13452 10.25 6.83333V4.05556C10.25 3.59532 9.86944 3.22222 9.4 3.22222C8.93056 3.22222 8.55 3.59532 8.55 4.05556M5.15 2.38889V5.44444M5.15 2.38889V1.83333C5.15 1.3731 5.53056 1 6 1C6.46944 1 6.85 1.3731 6.85 1.83333V2.38889M6.85 2.38889V5.44444M6.85 2.38889C6.85 1.92865 7.23056 1.55556 7.7 1.55556C8.16944 1.55556 8.55 1.92865 8.55 2.38889V4.05556M8.55 4.05556V5.44444" stroke="#F04438" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>}
                            
                        </div>
                    )}
                    <h1>{msgData.message.title}</h1>
                    <button className="close-hint aa-close-hint" aria-label="button">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#E3E8EF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                </div>
                <div className="body-hint">
                    <p>{msgData.message.body}</p>
                </div>
                <div className="footer-hint">
                    {msgData.adherence?.adType === 'ack' && (
                        <button className="aa-ackText-close">
                            {msgData.adherence?.ackText}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    const closeHint = (uQ: any) => {
        let inx = hints.findIndex((item: any)=> item.actionId === uQ);
        if(inx >= 0){
            const hintElement = hostInstance?.chatEle?.querySelector(`#${uQ}`);
            if (hintElement) {
                hintElement.remove();
                hints.splice(inx, 1);
                setCoachingHints(prevHints => prevHints.filter((hints: any) => hints.actionId !== uQ));
            }
        }
      }
    
    //   const hintScrollBottom = (flag: any) => {
    //     if(flag && this.overlayhint){
    //       this.overlayhint.nativeElement.scrollTop = 0;
    //     }
    //   }
    
    const hintAckPressed = (data: any) => {
    data["ackPressed"] = true;
    hostInstance.socketConnection.emitEvents(EVENTS.agent_coaching_ackpress, data);
    }

    const handleSentimentPopupOutSideClick = () => {
        window.onclick = function(event : any) {                        
            if (!event.target.matches('aa-sentiment-popup-wrapper') && !event.target.matches('sentiment-btn')) {
                let sentimentPopup = hostInstance?.chatEle?.querySelector?.(`${classConstants.SENTIMENT_POPUP_WRAPPER}`);
                if(sentimentPopup){
                    sentimentPopup.classList.add(classConstants.HIDE_ELEMENT);
                }
            } 
        }
    }
    const addSentimentPopupTemplate = () => {
        let sentimentPopupTemplate = getHTML(sentimentScore, {hostInstance}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, sentimentPopupTemplate, { event: SDK_EVENTS.SENTIMENT_POPUP_TEMPLATE, data : {} });
        let sentimentChart = hostInstance?.chatEle?.querySelector('.sentiment-chart-drp');
        sentimentChart?.append(sentimentPopupTemplate);
        hostInstance.eventManager?.addEventListener(`#${idMapConstants.SENTIMENT_POPUP_CLOSE_BTN}`, 'click', (e: any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.SENTIMENT_POPUP_WRAPPER}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, sentimentPopupTemplate);
    }

    const addHeaderTemplate = () => {
        let headerTemplate : any;
        let theme = hostInstance?.localStorageService?.getThemeLocal();  
        headerTemplate = getHTML(Header, {hostInstance, theme}, hostInstance);
        let headerSection = hostInstance?.chatEle?.querySelector(classConstants.HEADER);
        if(headerSection && headerTemplate){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, headerTemplate, { event: SDK_EVENTS.HEADER_TEMPLATE,  data : {}});
            headerSection.append(headerTemplate);

            hostInstance?.eventManager?.addEventListener(`#${idMapConstants.SETTINGS_BTN}`, 'click', (event: any) => {
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.SETTINGS_CLICK_EVENT, data : {} }); 
                hostInstance?.chatEle?.querySelector?.(`${classConstants.SETTINGS_POPUP}`).classList?.remove(classConstants.HIDE_ELEMENT);
            }, headerTemplate);

            hostInstance?.eventManager?.addEventListener(`#${idMapConstants.DARK_THEME_BTN}`, 'click', (event: any) => {
                toggleTheme(headerTemplate);
            }, headerTemplate);

            hostInstance?.eventManager?.addEventListener(`#${idMapConstants.LIGHT_THEME_BTN}`, 'click', (event: any) => {
               toggleTheme(headerTemplate);
            }, headerTemplate);
        }
    }

    const toggleTheme = (headerTemplate: any) => {
        let darkThemeBtn = headerTemplate?.querySelector?.(`#${idMapConstants.DARK_THEME_BTN}`);
        let lightThemeBtn = headerTemplate?.querySelector?.(`#${idMapConstants.LIGHT_THEME_BTN}`);

        let theme = hostInstance?.localStorageService?.getThemeLocal(); 
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.THEME_CHANGE_EVENT, data: {theme : theme === storageConst.LIGHT ? storageConst.DARK : storageConst.LIGHT} }); 
        if(theme === storageConst.LIGHT){
            hostInstance.applyBranding(DARKTHEME_COLORCODES, storageConst.DARK);
            hostInstance.localStorageService.setThemeLocal(storageConst.DARK);
            darkThemeBtn?.classList?.add(classConstants.HIDE_ELEMENT);
            lightThemeBtn?.classList?.remove(classConstants.HIDE_ELEMENT);
        }else{                    
            hostInstance.applyBranding(hostInstance?.config?.branding?.colors, storageConst.LIGHT);
            hostInstance.localStorageService.setThemeLocal(storageConst.LIGHT);
            darkThemeBtn?.classList?.remove(classConstants.HIDE_ELEMENT);
            lightThemeBtn?.classList?.add(classConstants.HIDE_ELEMENT);
        }
    }

    const addFooterTemplate = () => {
        let allTabs: any;
        let showTranscript = (hostInstance.rootService.connectionDetails.channel === ProjConstants.VOICE) && (hostInstance?.rootService?.aaSettings?.transcripts?.isEnabled);
        allTabs = getHTML(AllTabs,
            {
                tabsNTitles, selectedTab : serTabMap[selectTab], showTranscript, connectionDetails,
                sourceDesktop, hideUserBotHistory, projConstants: Tabs,
                selectedTheme, chooseTheme: chooseTheme, hostInstance,
                rootServiceInstance
            },
            hostInstance);

        let footerTag = hostInstance?.chatEle?.querySelector(classConstants.FOOTER);

        if (footerTag) {
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, allTabs, { event: SDK_EVENTS.FOOTER_TEMPLATE,  data : {tabsNTitles, footerTag}});
            footerTag.append(allTabs);
            tabsNTitles.forEach((tab: any) => {
                if(tab?.type !== Tabs.MORE){
                    hostInstance.eventManager?.addEventListener(`${classConstants.FOOTER_BTN}${tab.type}`, 'click', () => {
                        hostInstance.chatEle?.querySelector?.(`${classConstants.HINTS_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
                        hostInstance.chatEle?.querySelector?.(`${classConstants.NUDGES_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
                        toggleActiveTab(tab.type, footerTag);
                    }, footerTag);
                }else{
                    hostInstance.eventManager?.addEventListener(`${classConstants.FOOTER_BTN}${tab.type}`, 'click', ()=> {
                        hostInstance.chatEle?.querySelector?.(`${classConstants.HINTS_WRAPPER_FIXED}`)?.classList?.add(classConstants.HIDE_ELEMENT);
                        hostInstance.chatEle?.querySelector?.(`${classConstants.NUDGES_WRAPPER_FIXED}`)?.classList?.add(classConstants.HIDE_ELEMENT);
                        rootServiceInstance.moreBtnActive = !rootServiceInstance.moreBtnActive;
                        toggleMoreTab(footerTag)
                    }, footerTag)
                }
            });
        }
    }

    const toggleMoreTab = (footerTag:any) => {

        if(!rootServiceInstance.isWidgetFeedbackAPICalled){
            rootServiceInstance.isWidgetFeedbackAPICalled = true;
            const params = {
                botId: hostInstance.rootService.connectionDetails.botId,
                conversationId: hostInstance.rootService.connectionDetails.conversationId
            }

            rootServiceInstance.getWidgetFeedbackHistory(params, hostInstance).then((response: any) => {
                if(response && response?.results?.length > 0){
                    rootServiceInstance.widgetFeedbackData.positionId = response?.results[0]?.positionId || '';
                    rootServiceInstance.widgetFeedbackData.type = response?.results[0]?.feedback === 'like' ? 'positive' : 'negative';
                    rootServiceInstance.widgetFeedbackData.selectedSuggestions = response?.results[0]?.feedbackDetails || [];
                    rootServiceInstance.widgetFeedbackData.comment = response?.results[0]?.comment || '';
                    rootServiceInstance.widgetHistoryType = response?.results[0]?.feedback === 'like' ? 'positive' : 'negative';
                }
            }).catch((error: any) => {
                console.error('error in getting the Widget Feedback History', error);
            });
        }


        const existingOptionsTemplate = footerTag?.querySelector(`${classConstants.MULTIPLE_OPTIONS_POPUP}`)
        if(rootServiceInstance.moreBtnActive){
            if(existingOptionsTemplate){
                existingOptionsTemplate?.classList?.remove(classConstants.HIDE_ELEMENT)
            }else{
                addMultipleOptionsPopupTemplate(footerTag)
            }
        }else{
            hostInstance.chatEle?.querySelector?.(`${classConstants.HINTS_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            hostInstance.chatEle?.querySelector?.(`${classConstants.NUDGES_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            existingOptionsTemplate?.classList?.add(classConstants.HIDE_ELEMENT)
        }
    }

    const addMultipleOptionsPopupTemplate = (footerTag:any) => {
        const optionsTemplate = getHTML(RenderMultipleOptionsPopup, {moreOptions}, hostInstance)
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, optionsTemplate , {
            event: SDK_EVENTS.OVERALL_MORE_OPTIONS_TEMPLATE,
            data: {}
        });
        footerTag?.querySelector(`${classConstants.FOOTER_BTN}${Tabs.MORE}`)?.prepend(optionsTemplate)

        const optionsTemplateSelected:any = hostInstance?.chatEle?.querySelector(`${classConstants.MULTIPLE_OPTIONS_POPUP}`);

        hostInstance?.eventManager?.addEventListener(`${classConstants.OPTION_FEEDBACK}`, 'click', ()=>{
            hostInstance.chatEle?.querySelector?.(`${classConstants.HINTS_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            hostInstance.chatEle?.querySelector?.(`${classConstants.NUDGES_WRAPPER_FIXED}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            const feedbackPopupOverlay = hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_POPUP_OVERLAY}`);
            if(feedbackPopupOverlay){
                feedbackPopupOverlay?.classList?.remove(classConstants.HIDE_ELEMENT);
            }else{
                addFeedbackPopupTemplate()
            }
        },optionsTemplateSelected)
    }

    const addListViewPopupTemplate = () => {
        let listViewTemplate : any = getHTML(RenderListView, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, listViewTemplate, {
            event: SDK_EVENTS.LIST_VIEW_TEMPLATE,
            data : {}
        });
        hostInstance.chatEle?.append(listViewTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.LIST_VIEW_CLOSE_BTN}`, 'click', (e : any) => {
            rootServiceInstance.closeListView(hostInstance);
        }, listViewTemplate);
    }

    const addFeedbackPopupTemplate = () => {
        let feedbackPopupTemplate : any = getHTML(FeedbackPopupHTMLEle, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackPopupTemplate, {
            event: SDK_EVENTS.OVERALL_FEEDBACK_POPUP_TEMPLATE,
            data : {}
        });

        hostInstance.chatEle?.append(feedbackPopupTemplate);

        if(rootServiceInstance.widgetFeedbackData.type){
            const positiveFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.POSITIVE_FEEDBACK_INFO}`);
            const negativeFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.NEGATIVE_FEEDBACK_INFO}`);
            if(rootServiceInstance.widgetFeedbackData.type === 'positive'){
                addFeedbackPositiveSuggestion(feedbackPopupTemplate, positiveFeedbackBlock);
            }else{
                addFeedbackNegativeSuggestion(feedbackPopupTemplate, negativeFeedbackBlock);
            }
        }


        hostInstance.eventManager?.addEventListener?.(`${classConstants.FEEDBACK_POPUP_CLOSE_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_POPUP_OVERLAY}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, feedbackPopupTemplate);  

        hostInstance.eventManager?.addEventListener?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`, 'click', (e : any) => {
            if(!hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.hasAttribute('disabled')){
                hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.setAttribute('disabled', true);
            }
            hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_POPUP_OVERLAY}`).classList?.add(classConstants.HIDE_ELEMENT);
            rootServiceInstance.prepareAndMakeWidgetFeedbackRequest(hostInstance);

        }, feedbackPopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.FEEDBACK_SATISFIED_BTN}`, 'click', (e : any) => {

            if(hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.hasAttribute('disabled')){
                hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.removeAttribute('disabled');
            }

            const positiveFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.POSITIVE_FEEDBACK_INFO}`);
            const negativeFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.NEGATIVE_FEEDBACK_INFO}`);

            toggleOverallFeedbackActiveButton(true);

            if(rootServiceInstance.widgetFeedbackData.type === 'negative'){
                rootServiceInstance.widgetFeedbackData.type = 'positive';
                rootServiceInstance.widgetFeedbackData.selectedSuggestions = [];
                rootServiceInstance.widgetFeedbackData.comment = '';
            }

            if(negativeFeedbackBlock){
                negativeFeedbackBlock?.classList?.add(classConstants.HIDE_ELEMENT)
            }

            addFeedbackPositiveSuggestion(feedbackPopupTemplate, positiveFeedbackBlock)

        }, feedbackPopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.FEEDBACK_UNSATISFIED_BTN}`, 'click', (e : any) => {
        
            const positiveFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.POSITIVE_FEEDBACK_INFO}`);
            const negativeFeedbackBlock = feedbackPopupTemplate?.querySelector(`${classConstants.NEGATIVE_FEEDBACK_INFO}`);

            toggleOverallFeedbackActiveButton(false);

            if(positiveFeedbackBlock){
                positiveFeedbackBlock?.classList?.add(classConstants.HIDE_ELEMENT)
            }

            addFeedbackNegativeSuggestion(feedbackPopupTemplate, negativeFeedbackBlock)

        }, feedbackPopupTemplate);

    }

    const addFeedbackPositiveSuggestion = (feedbackPopupTemplate: any, positiveFeedbackBlock: any) => {

        if(positiveFeedbackBlock){
            positiveFeedbackBlock?.classList?.remove(classConstants.HIDE_ELEMENT)
        }else{
            addPositiveFeedbackBlock(feedbackPopupTemplate)
        }
    }

    const addPositiveFeedbackBlock = (feedbackPopupTemplate: any) => {
        let positiveSuggestionList:any = [];

        let isDefaultSuggestionList:boolean = false;
        
        const language = hostInstance?.localStorageService?.getLanguage() || 'en';

        if(rootServiceInstance.aaSettings?.feedback?.widget?.positiveKeyWords?.[language]?.length > 0){
            positiveSuggestionList = rootServiceInstance.aaSettings?.feedback?.widget?.positiveKeyWords?.[language]?.filter((item: any) => item?.isEnabled);
        }else{
            isDefaultSuggestionList = true;
            positiveSuggestionList = FeebackConst.DEFAULT_SUGGESTION.positiveDialogs[language as keyof typeof FeebackConst.DEFAULT_SUGGESTION.positiveDialogs];
        }
    
        const showComments = rootServiceInstance.aaSettings?.feedback?.widget?.acceptComment;
        const overallFeedbackSection = getHTML(OverallFeedbackSection, {suggestionList : positiveSuggestionList, isDefaultSuggestionList : isDefaultSuggestionList, showComments : showComments, type: 'positive'}, hostInstance);

        if(overallFeedbackSection){

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, overallFeedbackSection, {
                event: SDK_EVENTS.OVERALL_WIDGET_FEEDBACK_POSITIVE_TEMPLATE,
                data : {suggestionList : positiveSuggestionList, isDefaultSuggestionList : isDefaultSuggestionList, showComments : showComments, type: 'positive'}
            });

            feedbackPopupTemplate?.querySelector?.(`${classConstants.FEEDBACK_POPUP_BODY}`)?.append(overallFeedbackSection);
            rootServiceInstance?.handleWidgetFeedbackClickEvents(overallFeedbackSection, 'positive',hostInstance);
        }
    }

    const addFeedbackNegativeSuggestion = (feedbackPopupTemplate: any, negativeFeedbackBlock: any) => {

        if(negativeFeedbackBlock){
            if((rootServiceInstance.widgetFeedbackData.selectedSuggestions?.length > 0 || rootServiceInstance.widgetFeedbackData.comment?.length > 0) && rootServiceInstance.widgetFeedbackData.type !== 'negative'){
                hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.setAttribute('disabled',true)
            }    
            negativeFeedbackBlock?.classList?.remove(classConstants.HIDE_ELEMENT)
        }else{
            addNegativeFeedbackBlock(feedbackPopupTemplate)
        }
    }

    const addNegativeFeedbackBlock = (feedbackPopupTemplate: any) => {
        let negativeSuggestionList:any = [];

        let isDefaultSuggestionList:boolean = false;

        const language = hostInstance?.localStorageService?.getLanguage() || 'en';

        if(rootServiceInstance.aaSettings?.feedback?.widget?.negativeKeyWords?.[language]?.length > 0){
            negativeSuggestionList = rootServiceInstance.aaSettings?.feedback?.widget?.negativeKeyWords?.[language]?.filter((item: any) => item?.isEnabled);
        }else{
            isDefaultSuggestionList = true;
            negativeSuggestionList = FeebackConst.DEFAULT_SUGGESTION.dialogs[language as keyof typeof FeebackConst.DEFAULT_SUGGESTION.dialogs];
        }

        const showComments = rootServiceInstance.aaSettings?.feedback?.widget?.acceptComment;
        const overallFeedbackSection = getHTML(OverallFeedbackSection, {suggestionList : negativeSuggestionList, isDefaultSuggestionList : isDefaultSuggestionList, showComments : showComments, type: 'negative'}, hostInstance);

        if(overallFeedbackSection){

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, overallFeedbackSection, {
                event: SDK_EVENTS.OVERALL_WIDGET_FEEDBACK_NEGATIVE_TEMPLATE,
                data : {suggestionList : negativeSuggestionList, isDefaultSuggestionList : isDefaultSuggestionList, showComments : showComments, type: 'negative'}
            });

            feedbackPopupTemplate?.querySelector?.(`${classConstants.FEEDBACK_POPUP_BODY}`)?.append(overallFeedbackSection);
            hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SUBMIT_BTN}`)?.setAttribute('disabled',true)
            rootServiceInstance?.handleWidgetFeedbackClickEvents(overallFeedbackSection, 'negative', hostInstance);   
        }
    }

    const toggleOverallFeedbackActiveButton = (isLike: boolean) => {

        let activeElement:HTMLElement;
        let inactiveElement:HTMLElement;

        if(isLike){
            activeElement = hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SATISFIED_BTN}`);
            inactiveElement = hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_UNSATISFIED_BTN}`);

        }else{
            activeElement = hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_UNSATISFIED_BTN}`);
            inactiveElement = hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_SATISFIED_BTN}`);
        }

        activeElement?.classList?.add('active');
        inactiveElement?.classList?.remove('active');
    }

    const addTerminatePopupTemplate = () => {
        let terminatePopupTemplate  = getHTML(RenderTerminatePopup, {}, hostInstance);

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, terminatePopupTemplate, {
            event: SDK_EVENTS.TERMINATE_POPUP_TEMPLATE,
            data : {}
        });

        hostInstance.chatEle?.append(terminatePopupTemplate);
        
        hostInstance.eventManager?.addEventListener?.(`${classConstants.TERMINATE_YES_BTN}`, 'click', (e : any) => {
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.TERMINATE_CLICK_EVENT, data: {activeTab : rootServiceInstance.activeTab} });
            hostInstance.emit(INTERNAL_EVENTS.TERMINATE_EVENT, {activeTab : rootServiceInstance.activeTab});
        }, terminatePopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.TERMINATE_CANCEL_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMIANTE_POPUP}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, terminatePopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.TERMINATE_OVERRIDE_BTN}`, 'click', (e : any) => {
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.TERMINATE_CLICK_EVENT, data: {activeTab : rootServiceInstance.activeTab} });
            hostInstance.emit(INTERNAL_EVENTS.TERMINATE_OVERRIDE_EVENT, {activeTab : rootServiceInstance.activeTab});
        }, terminatePopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.TERMINATE_CLOSE_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.TERMIANTE_POPUP}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, terminatePopupTemplate);
    }

    const addInterruptPopupTemplate = () => {
        let interruptPopupTemplate  = getHTML(RenderInterruptionPopup, {}, hostInstance);

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, interruptPopupTemplate, {
            event: SDK_EVENTS.INTERRUPT_POPUP_TEMPLATE,
            data : {}
        });

        hostInstance.chatEle?.append(interruptPopupTemplate);
        
        hostInstance.eventManager?.addEventListener?.(`${classConstants.INTERRUPT_ACCEPT_BTN}`, 'click', (e : any) => {
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.INTERRUPT_CLICK_EVENT, data: {activeTab : rootServiceInstance.activeTab} });
            hostInstance.emit(INTERNAL_EVENTS.INTERRUPT_ACCEPT_EVENT, {activeTab : rootServiceInstance.activeTab});
        }, interruptPopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.INTERRUPT_CANCE_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.INTERRUPT_POPUP}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, interruptPopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.INTERRUPT_RUNLATER_BTN}`, 'click', (e : any) => {
            hostInstance.emit(INTERNAL_EVENTS.INTERRUPT_RUNLATER_EVENT, {activeTab : rootServiceInstance.activeTab});
        }, interruptPopupTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.INTERRUPT_CLOSE_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.INTERRUPT_POPUP}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, interruptPopupTemplate);
    }

    const addSettingsTemplate = () => {
        let settingsTemplate = getHTML(RenderSettingsPopup, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, settingsTemplate, { event: SDK_EVENTS.SETTINGS_TEMPLATE, data : {} });
        hostInstance?.chatEle?.append(settingsTemplate);

        
        hostInstance.eventManager?.addEventListener?.(`${classConstants.SETTINGS_POPUP_CLOSE_BTN}`, 'click', (e : any) => {
            hostInstance?.chatEle?.querySelector?.(`${classConstants.SETTINGS_POPUP}`).classList?.add(classConstants.HIDE_ELEMENT);
        }, settingsTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.SETTINGS_POPUP_BACK_BTN}`, 'click', (e: any) => {
            toggleSettingsElements('add', 'both');
        }, settingsTemplate);
        
        hostInstance.eventManager?.addEventListener?.(`${classConstants.SETTINGS_HELP_BTN}`, 'click', (e: any) => {
            toggleSettingsElements('remove', 'help');
        }, settingsTemplate);
        
        hostInstance.eventManager?.addEventListener?.(`${classConstants.SETTINGS_HELP_SECTION}`, 'click', (e: any) => {
            toggleSettingsElements('remove', 'help');
        }, settingsTemplate); 

        hostInstance?.eventManager?.addEventListener(`${classConstants.SETTINGS_LANGUAGE_SECTION}`, 'click', (event: any) => {
            toggleSettingsLanguageElements('remove');
        }, settingsTemplate);

        hostInstance?.chatEle?.querySelector(`${classConstants.SETTINGS_LANGUAGE_GROUP}`)?.querySelectorAll(`${classConstants.SETTINGS_LANGUAGE_SELECT}`)?.forEach((element:any )=> {
            element.addEventListener('change', (event: any) => {
                event.stopPropagation();
                const inputElement = event.target as HTMLInputElement;                
                if(inputElement){
                    disableLanguageSettingsElements(hostInstance?.chatEle?.querySelector(`${classConstants.SETTINGS_LANGUAGE_GROUP}`));
                    localStorageServiceInstance.setLanguageInfo(event.target.value)
                    hostInstance?.removeEventListenersInDOM();
                    hostInstance?.show(hostInstance?.config,hostInstance?.languagePluginService?.config)
                }
            });
        });

        hostInstance?.eventManager?.addEventListener(`${classConstants.SETTINGS_AUTO_SCROLL}`, 'click', (event: any) => {
            let inputElement;
            if(event.target.nodeName === 'INPUT'){
                inputElement = event?.target as HTMLInputElement;
                inputElement.checked = !inputElement.checked;
            }else{
                inputElement = event?.currentTarget?.querySelector('input[type="checkbox"]') as HTMLInputElement;
            }
            
            if(inputElement && !inputElement.disabled){
                inputElement.checked = !inputElement.checked;
                rootServiceInstance.autoScrollStatus = inputElement.checked;
                hostInstance.localStorageService.setAutoScroll(inputElement.checked);
                hostInstance?.emit(DATA_EVENTS.AUTO_SCROLL_CHANGE, inputElement.checked);
            }
            
        }, settingsTemplate);

        hostInstance?.eventManager?.addEventListener(`#${idMapConstants.PROACTIVE_BTN}`, 'click', (event: any) => {
            let inputElement;
            if(event.target.nodeName === 'INPUT'){
                inputElement = event?.target as HTMLInputElement;
                inputElement.checked = !inputElement.checked;
            }else{
                inputElement = event?.currentTarget?.querySelector('input[type="checkbox"]') as HTMLInputElement;
            }
            if (inputElement && !inputElement.disabled) {
                // Toggle the checked state
                inputElement.checked = !inputElement.checked;

                // Trigger any logic that depends on the checked state
                rootServiceInstance.proactiveMode = inputElement.checked;
                hostInstance.localStorageService.setProactiveMode(inputElement.checked);
                hostInstance?.emit(DATA_EVENTS.PRO_ACTIVE_CHANGE, inputElement.checked);
                hostInstance?.handleOverrideMode(!inputElement.checked);
                if (event.isTrusted) {
                    hostInstance.socketConnection.dialogEntityExtraction = false;
                }
            }
        }, settingsTemplate);
        

        hostInstance?.eventManager?.addEventListener(`${classConstants.SETTINGS_FAQ_LINK}`, 'click', (event: any) => {
            openLink(ProjConstants.FAQ_LINK, ProjConstants.SETTINGS_FAQ);
        }, settingsTemplate);   

        hostInstance?.eventManager?.addEventListener(`${classConstants.SETTINGS_DOCUMENTATION_LINK}`, 'click', (event: any) => {            
            openLink(ProjConstants.DOCUMENTATION_LINK, ProjConstants.SETTINGS_DOCUMENTATION);
        }, settingsTemplate);

        hostInstance?.eventManager?.addEventListener(`${classConstants.SETTINGS_KORE_ACADEMY_LINK}`, 'click', (event: any) => {
            openLink(ProjConstants.KOREACADEMY_LINK, ProjConstants.SETTINGS_KOREACADEMY);
        }, settingsTemplate);

    }

    function openLink(url : string, type : string) {
        let openUrl = rootServiceInstance.settingsData?.showHelp[type]?.resource || url;
        rootServiceInstance.openurlInBrowser(openUrl);
    }

    function disableLanguageSettingsElements(element:any){
        hostInstance?.renderIndividualLoader(element);
        const inputElementArr = element.querySelectorAll?.(`input`);
        inputElementArr.forEach((inputElement:any )=> {
            inputElement.disabled = true;
        })
    }

    function toggleSettingsElements(action: 'add' | 'remove', type: 'help' | 'both') {
        const method = action === 'add' ? 'add' : 'remove';
        const settingsMethod = action === 'add' ? 'remove' : 'add';
        const settingsQuerySelector =hostInstance?.chatEle?.querySelector?.(`${classConstants.SETTINGS_POPUP}`)
        
        if(type === 'both') {
            settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_HELP_GROUP}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
            settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_LANGUAGE_GROUP}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        }else{
            settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_HELP_GROUP}`)?.classList?.[method](classConstants.HIDE_ELEMENT);  
        }
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_NEXT_BTN}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_MAIN_SECTION}`)?.classList?.[settingsMethod](classConstants.HIDE_ELEMENT);
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_POPUP_BACK_BTN}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        if(action === 'remove') {
            hostInstance.chatEle.querySelector(`${classConstants.SETTINGS_POPUP}`).querySelector(`${classConstants.SETTINGS_NEXT_BTN}`).textContent = ` / ${languageData?.HELP}`;
        }
    }

    function toggleSettingsLanguageElements(action: 'add' | 'remove') {
        const settingsQuerySelector =hostInstance?.chatEle?.querySelector?.(`${classConstants.SETTINGS_POPUP}`)
        const method = action === 'add' ? 'add' : 'remove';
        const settingsMethod = action === 'add' ? 'remove' : 'add';
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_LANGUAGE_GROUP}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_NEXT_BTN}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_MAIN_SECTION}`)?.classList?.[settingsMethod](classConstants.HIDE_ELEMENT);
        settingsQuerySelector?.querySelector?.(`${classConstants.SETTINGS_POPUP_BACK_BTN}`)?.classList?.[method](classConstants.HIDE_ELEMENT);
        if(action === 'remove') {
            hostInstance.chatEle.querySelector(`${classConstants.SETTINGS_POPUP}`).querySelector(`${classConstants.SETTINGS_NEXT_BTN}`).textContent = ` / ${languageData?.LANGUAGE}`;
        }
    }

    const addAttachmentViewTemplate = () => {
        let attachmentviewTemplate = getHTML(RenderAttachmentImageView, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, attachmentviewTemplate, { event: SDK_EVENTS.ATTACHMENT_VIEW, data : {} });
        hostInstance?.chatEle?.append(attachmentviewTemplate);

        let attachmentView = hostInstance?.chatEle?.querySelector(`${classConstants.ENTITY_ATTACHMENT_VIEW_MODAL}`);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.ENTITY_ATTACHMENT_BACK_BTN}`, 'click', (e : any) => {
           attachmentView?.classList?.add(classConstants.HIDE_ELEMENT);
        }, attachmentviewTemplate);
        hostInstance.eventManager?.addEventListener?.(`${classConstants.ENTITY_ATTACHMENT_CLOSE_BTN}`, 'click', (e : any) => {
            attachmentView?.classList?.add(classConstants.HIDE_ELEMENT);
         }, attachmentviewTemplate);
    }

    const addFeedbackToastrTemplate = () => {

        let feedbackToastTemplate = getHTML(FeedbackToast, {}, hostInstance);

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackToastTemplate, {
            event: SDK_EVENTS.FEEDBACK_TOAST_TEMPLATE,
            data : {}
        });

        hostInstance?.chatEle?.append(feedbackToastTemplate);

        hostInstance.eventManager?.addEventListener?.(`${classConstants.FEEDBACK_CLOSE_BTN}`, 'click', (e : any) => {
            hideFeedbackToastr();
        }, feedbackToastTemplate);
    }

    const hideFeedbackToastr = () => {
        hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_TOASTR}`).classList?.add(classConstants.HIDE_ELEMENT);
    }

    const showFeedbackToastr = () => {
        hostInstance?.chatEle?.querySelector?.(`${classConstants.FEEDBACK_TOASTR}`).classList?.remove(classConstants.HIDE_ELEMENT);
    }

    const handleFeedbackResponse = (response : any) => {
        if (response && Object.keys(response)?.length > 0) {
            if(response?.feedback === 'like' || (response?.feedback === 'dislike' && (rootServiceInstance?.isUpdateFeedBackDetailsFlag || response?.interactionType === 'widget'))){
              showFeedbackToastr();
              if (timeoutId.current !== undefined) {
                clearTimeout(timeoutId.current); // Clear existing timeout if any
              }
              timeoutId.current = window.setTimeout(() => {
                hideFeedbackToastr();
              }, 5000);
            }
        }
        if(response.type === 'summary'){
            let positionId = response.positionId;
            let feedbackSummaryData = rootServiceInstance.generatedSummaries.find((item : any) => item.positionId === positionId);
            if(feedbackSummaryData){
                feedbackSummaryData.summaryFeedbackData = response;
            }
        }
    }

    const toggleActiveTab = (activeTab: any, footerTag: any) => {   
        let isEnabled = tabsNTitles.find((tab: any) => tab.type === activeTab)?.isEnabled;
        if(isEnabled){
            updateTabActive(activeTab);
            tabsNTitles.forEach((tab: any) => {
            let footerTabEle = footerTag.querySelector(`${classConstants.FOOTER_BTN}${tab.type}`);
            if (footerTabEle && tab.type === activeTab) {
                footerTabEle?.classList?.add(...["selected-tab", "sel-bg"]);
            } else if(footerTabEle) {
                footerTabEle?.classList?.remove(...["selected-tab", "sel-bg"]);
                }
            })
        }
    }

    const updateTabActive = (tab : string, removeOtherTabs = true)=>{   
        if(tab){
            rootServiceInstance.activeTab = tab;
            selectTab = tab;
        }else{
            rootServiceInstance.activeTab = localStorageServiceInstance.getActiveTab();
            tab = rootServiceInstance.activeTab;
            selectTab = rootServiceInstance.activeTab;
        }
        if(removeOtherTabs){
            setAssistTabActive(false);
            setMybotTabActive(false);
            setSearchTabActive(false);
            setTranscriptTabActive(false);
            setplaybookTabActive(false);
            setCustomTabActive(false);
        }
        switch (tab) {
            case 'ast':
                setAssistTabActive(true);
                break;
            case 'srch':
                setSearchTabActive(true);
                break;
            case 'mB':
                setMybotTabActive(true);
                break;
            case 'trnspt':
                setTranscriptTabActive(true);
                break;
            case 'cl':
                setplaybookTabActive(true);
                break;
            case 'cst':
                setCustomTabActive(true);
                break;
            default:
                setAssistTabActive(true);
                break;
        }

        if(tab){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, '', { event: SDK_EVENTS.TAB_CHANGE_EVENT, data: {activeTab : tab} });
            localStorageServiceInstance.setActiveTab(serviceTabMap[tab]);
        }
    }


    const handlePauseResumeTranscript = (transcriptionStatus: string) => {
        const payload = {
            conversationId: hostInstance?.rootService.connectionDetails.conversationId,
            botId: hostInstance?.rootService.connectionDetails.botId,
            transcriptionStatus,
            experience: hostInstance?.rootService.connectionDetails.channel    
        }
        hostInstance.socketConnection.emitEvents(EVENTS.desktop_activity_request, payload);
    }


    // intermittent summary changes start

    const updateFeedbackForEachPrevSummary = () => {
        setTimeout(() => {
            rootServiceInstance?.generatedSummaries?.map((item: any, index: number) => {
                if(item?.type != 'final'){
                    let prevSummaryFeedbackWrapper = hostInstance?.chatEle?.querySelector(`${classConstants.PREV_SUMMARY_FEEDBACK_WRAPPER}${index}`);                    
                    if(prevSummaryFeedbackWrapper){
                        removeFeedbackSummary(prevSummaryFeedbackWrapper);
                        updateSummaryFeedback(prevSummaryFeedbackWrapper, item?.positionId, item?.summaryId, item?.traceId, item?.exeStartTime);
                    }
                }
            })
        });
                                    
    }

    const handleSummaryPopup = (respData : any) => {
        let summaryPopupModal = hostInstance?.chatEle?.querySelector('#aa-conv-summary');
        let summaryWrapper = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        let summaryClassList = summaryWrapper?.classList;

        // addToPrevioisAndClearSummary(respData);

        const isSummaryEnabled = rootServiceInstance.aaSettings?.summarization['localeData'][rootServiceInstance.connectionDetails.interactiveLanguage || 'en']?.isEnabled;
        if (!isSummaryEnabled) {
            localStorageServiceInstance.deleteLocalStorageState(rootServiceInstance.connectionDetails.conversationId);
            return;
        }

        const summaryOverlayEle = document.getElementsByClassName(idMapConstants.SUMMARY_OVERLAY_BLOCK)[0];

        if (isSummaryEnabled && (respData.initPopup || respData.openOnResponse || respData.openToShowPreviousSummary) && !summaryPopupModal) {
            const summaryObj: any = getHTML(SummaryPopupHTMLEle, respData, hostInstance);
            summaryOverlayEle?.append(summaryObj);  

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, summaryObj, {
                event: SDK_EVENTS.SUMMARY_POPUP_TEMPLATE,
                data : respData
            });

            hostInstance.eventManager?.addEventListener('.aa-delete-summary-text', 'click', () => {
                deleteSummaryText();
                disableOrEnableSummaryCloseButton(true);
                disableOrEnableSummarySubmitButton(true);
                disableOrEnableSummaryCopyButton(true);
                removeOrAddDeleteSummaryButton(true);
            }, summaryObj);

            hostInstance.eventManager?.addEventListener('.aa-summit-summary-text', 'click', () => {
                submitSummaryResolution();
            }, summaryObj);

            hostInstance.eventManager?.addEventListener('.aa-copy-summary-text', 'click', (event: any) => {
                event.target.textContent = 'Copied';
                setTimeout(() => {
                    event.target.textContent = 'Copy';
                }, 3000);
                copySummaryResolution();
            }, summaryObj);

            hostInstance.eventManager?.addEventListener(`${classConstants.SUMMARY_REFRESH_BTN}`, 'click', () => {
                regenerateSummary();
            }, summaryObj);

            hostInstance.eventManager?.addEventListener(`${classConstants.SUMMARY_CLOSE_BTN}`, 'click', () => {
                submitSummaryResolution();
            }, summaryObj);

            hostInstance?.eventManager?.addEventListener('.aa-summary-text-input', 'input', (event: any) => {
                if (event.target.value) {
                    removeOrAddDeleteSummaryButton(false);
                    disableOrEnableSummarySubmitButton(false);
                    disableOrEnableSummaryCopyButton(false);
                    disableOrEnableSummaryCloseButton(false);
                } else {
                    removeOrAddDeleteSummaryButton(true);
                    disableOrEnableSummarySubmitButton(true);
                    disableOrEnableSummaryCopyButton(true);
                    disableOrEnableSummaryCloseButton(true);
                }

            }, summaryOverlayEle);

            hostInstance.eventManager?.addEventListener(`${classConstants.SUMMARY_PREVIOUS_BTN}`, 'click', () => {
                let summaryContentCollapse = summaryOverlayEle.querySelector(`${classConstants.SUMMARY_CONTENT_COLLAPSE}`);
                summaryContentCollapse?.classList.toggle('aa-hidden');
            }, summaryObj);

            hostInstance.eventManager?.addEventListener(`${classConstants.SUMMARY_MINIMIZE_BTN}`, 'click', () => {
                dragIntermSumm();
                hideSummary();
            }, summaryObj);

            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, summaryObj, {
                event: SDK_EVENTS.CONVERSATION_SUMMARY_TEMPLATE,
                respData
            });

        } else if (!respData.initPopup && respData.openToShowPreviousSummary) {          
            showSummary();
        } else if(rootServiceInstance.finalSummaryGenerated && respData.openOnResponse){
            showSummary();
        }

        if(rootServiceInstance.finalSummaryGenerated){
            showOrHideSummaryTextArea(true);
        }else if (!respData.positionId && !respData.summaryId){
            showOrHideSummaryTextArea(false);
        }

        addSummaryToList(respData);
        updateTextAreaSummary({ ...respData });
        updateGeneratedSummariesCount();
        enableOrDisableButtons(respData, summaryOverlayEle);
        updateFeedbackForEachPrevSummary();
    }

    const enableOrDisableButtons = (respData : any, summaryOverlayEle : any) => {      
        if(respData.initPopup){
            disableOrEnableSummarySubmitButton(true);
            disableOrEnableSummaryCopyButton(true);
            disableOrEnableSummaryCloseButton(true);
            disableOrEnableSummaryRefreshButton(true);
            removeOrAddDeleteSummaryButton(true);
            addOrRemoveLoaderToSummary(true);
        }else{
            addOrRemoveLoaderToSummary(false);
            disableOrEnableSummaryCloseButton(false);
            let hideRefreshButton = rootServiceInstance.summaryInProgress || rootServiceInstance.maxIntSummaryCount <= rootServiceInstance.currentGenIntSummaryCount ||rootServiceInstance.finalSummaryGenerated        
            disableOrEnableSummaryRefreshButton(hideRefreshButton);
        }

        let summaryTextArea = summaryOverlayEle?.querySelector('#summaryText');
        
        if(!summaryTextArea?.value || summaryTextArea?.value === 'undefined'){
            disableOrEnableSummarySubmitButton(true);
            disableOrEnableSummaryCopyButton(true);
        }else{
            disableOrEnableSummarySubmitButton(false);
            disableOrEnableSummaryCopyButton(false);
            removeOrAddDeleteSummaryButton(false);
        }

        if(rootServiceInstance.finalSummaryGenerated && respData.openToShowPreviousSummary){
            disableOrEnableSummarySubmitButton(true);
            disableOrEnableSummaryCopyButton(true);
            removeOrAddDeleteSummaryButton(true);
        }

    }

    const disableOrEnableSummarySubmitButton = (disable : boolean) => {
        const summarySubmitButton = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_SUBMIT_BTN}`);
        if(summarySubmitButton){
            if(disable){
                summarySubmitButton.setAttribute('disabled', 'disabled');
            }else{
                summarySubmitButton.removeAttribute('disabled');
            }
        }
    }

    const disableOrEnableSummaryCopyButton = (disable : boolean) => {
        const summaryCopyButton = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_COPY_BTN}`);
        if(summaryCopyButton){
            if(disable){
                summaryCopyButton.setAttribute('disabled', 'disabled');
            }else{
                summaryCopyButton.removeAttribute('disabled');
            }
        }
    }

    const disableOrEnableSummaryCloseButton = (disable : boolean) => {
        const summaryCloseButton = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_CLOSE_BTN}`);
        if(summaryCloseButton){
            if(disable){
                summaryCloseButton.setAttribute('disabled', 'disabled');
            }else{
                summaryCloseButton.removeAttribute('disabled');
            }
        }
    }

    const disableOrEnableSummaryRefreshButton = (disable : boolean) => {
        const summaryRefreshButton = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_REFRESH_BTN}`);
        let disabled = disable || rootServiceInstance.generatedSummaries.length > 1
        if(summaryRefreshButton){
            if(disabled){
                summaryRefreshButton.setAttribute('disabled', 'disabled');
            }else{
                summaryRefreshButton.removeAttribute('disabled');
            }
        }
    }


    const removeOrAddDeleteSummaryButton = (remove : boolean) => {
        const summaryDeleteButton = hostInstance?.chatEle?.querySelector(`${classConstants.SUMMARY_DELETE_BTN}`);        
        if(summaryDeleteButton){
            summaryDeleteButton.classList.toggle('aa-hidden', remove);
        }
    }
    

    const updateTextAreaSummary = (respData : any) => {
        let summaryWrapper = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        let summaryContentArea = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_CONTENT_AREA}`);
        if(rootServiceInstance?.finalSummaryGenerated && !respData?.openToShowPreviousSummary){
            summaryContentArea?.classList?.remove(classConstants.HIDE_ELEMENT);
        }
        let summaryTextArea = hostInstance?.chatEle?.querySelector('#summaryText');

        // let finalSummaryText = rootServiceInstance?.generatedSummaries?.find((item : any) => item?.type === 'final')?.summary || respData?.summaryText || '';
        let finalSummaryObj = rootServiceInstance?.generatedSummaries?.find((item : any) => item?.type === 'final') || respData;        
        if(summaryTextArea){
            //add attributes to the text area
            summaryTextArea?.setAttribute('data-summaryId', finalSummaryObj?.summaryId || '');
            summaryTextArea?.setAttribute('data-positionId', finalSummaryObj?.positionId || '');
            summaryTextArea?.setAttribute('data-traceId', respData?.traceId || '');
            summaryTextArea?.setAttribute('data-exeStartTime', respData?.exeStartTime || '');
            summaryTextArea.value = finalSummaryObj.editedSummary || finalSummaryObj.summary;
            if(!respData.initPopup && !summaryContentArea?.classList?.contains(classConstants.HIDE_ELEMENT)){
                removeFeedbackSummary(summaryWrapper?.querySelector(`.actions-footer`));
                addFeedbackToSummary();
                updateFeedbackForMainSummary();
            }else{
                removeFeedbackSummary(summaryWrapper?.querySelector(`.actions-footer`));
            }
        }
    }

    const hideSummary = () => {
        let summaryWrapper = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        summaryWrapper?.classList?.add('aa-hidden');
    }

    const handleSummaryResolutionComments = (respData: any) => {        
        const summary = respData?.isError ? 
        languageData?.SUMMARY_ERROR_TEXT
        : respData.summary[0];
        setEditedSummaryText(summary);        
        hostInstance.socketConnection.emitEvents(EVENTS.response_resolution_comments_ack, respData, true);
        hostInstance.setSummaryPopup({...respData, summaryText : summary, openOnResponse : true}); 
    }

    const updatePreviousSummary = (props: any) => {
        let summaryText = props?.msgData?.summaryText;
        let index = props?.msgData?.summaryIndex;
        return (
            <div className="summery-accordion-content">
                <div className="summery-accordion-content-inner-sec">
                    <div className="summery-accordion-content-inner-sec-item aa-text-xs">{summaryText}</div>
                </div>
                <div className={`summery-accordion-content-item-date-time aa-prev-summary-${index}`}>

                </div>
            </div>
        )
    }

    const FeedbackPopupHTMLEle = (props: any) => {
        const languageData = props?.hostInstance?.languagedata;
        const widgetFeedbackData = props?.hostInstance.rootService.widgetFeedbackData;
        
        return (
            <div className="aa-feedback-popup-overlay feedback-popup-overlay a-position-absolute a-flex a-justify-content-center a-align-items-center a-width-100 a-height-100">
                <div className="feedback-popup-container a-radius-8 a-padding-sm a-flex a-flex-column a-gap-8">
                    <div className="feedback-popup-header a-flex a-align-items-center a-width-100">
                        <span className="feedback-popup-title aa-text-sm semibold w-100 text-truncate">{languageData?.SUBMIT_OVERALL_FEEDBACK}</span>
                        <button className="feedback-popup-close-btn aa-feedback-popup-close-btn cursor-pointer" aria-label="Close feedback dialog">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M12 4L4 12M4 4L12 12" stroke="#667085" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <div className="feedback-popup-body aa-feedback-popup-body a-width-100 a-flex a-flex-column a-gap-4">
                      <div className="feedback-popup-body-content a-padding-sm a-radius-8 a-width-100 a-flex a-flex-column a-gap-4">
                        <p className="aa-text-xs medium">{languageData?.FEEDBACK_QUESTION}</p>
                            <div className="feedback-satisfaction-options a-flex a-gap-8 a-width-100">
                                <button className={`feedback-option-btn feedback-satisfied-btn aa-feedback-satisfied-btn a-flex a-align-items-center a-justify-content-center a-gap-4 a-radius-6 cursor-pointer aa-text-xs medium a-width-100 ${widgetFeedbackData.type === 'positive' ? 'active' : ''}`}>
                                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                                    <path d="M3 10.5V5M0.5 6V9.5C0.5 10.0523 0.947715 10.5 1.5 10.5H8.21312C8.95348 10.5 9.5831 9.95983 9.69568 9.22809L10.2341 5.72809C10.3739 4.81945 9.67091 4 8.75158 4H7C6.72386 4 6.5 3.77614 6.5 3.5V1.73292C6.5 1.052 5.948 0.5 5.26708 0.5C5.10467 0.5 4.95749 0.595648 4.89153 0.744061L3.13197 4.70307C3.05172 4.88363 2.87266 5 2.67506 5H1.5C0.947715 5 0.5 5.44772 0.5 6Z" stroke="#079455" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {languageData?.FEEDBACK_SATISFIED}
                                </button>
                                <button className={`feedback-option-btn feedback-unsatisfied-btn aa-feedback-unsatisfied-btn a-flex a-align-items-center a-justify-content-center a-gap-4 a-radius-6 cursor-pointer aa-text-xs medium a-width-100 ${widgetFeedbackData.type === 'negative' ? 'active' : ''}`}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path d="M8.49954 1V6.5M10.9995 4.9V2.6C10.9995 2.03995 10.9995 1.75992 10.8905 1.54601C10.7947 1.35785 10.6417 1.20487 10.4535 1.10899C10.2396 1 9.95959 1 9.39954 1H4.05854C3.3278 1 2.96243 1 2.66733 1.13372C2.40724 1.25157 2.18619 1.44121 2.03016 1.68036C1.85312 1.9517 1.79757 2.31282 1.68645 3.03506L1.42491 4.73506C1.27836 5.68766 1.20508 6.16395 1.34644 6.53456C1.47051 6.85985 1.70386 7.13185 2.0065 7.30393C2.3513 7.5 2.8332 7.5 3.79701 7.5H4.19954C4.47956 7.5 4.61958 7.5 4.72653 7.5545C4.82061 7.60243 4.8971 7.67892 4.94504 7.773C4.99954 7.87996 4.99954 8.01997 4.99954 8.3V9.76708C4.99954 10.448 5.55154 11 6.23246 11C6.39487 11 6.54205 10.9044 6.60801 10.7559L8.28839 6.97509C8.36482 6.80312 8.40303 6.71714 8.46344 6.65409C8.51683 6.59836 8.5824 6.55575 8.65501 6.52959C8.73716 6.5 8.83125 6.5 9.01944 6.5H9.39954C9.95959 6.5 10.2396 6.5 10.4535 6.39101C10.6417 6.29513 10.7947 6.14215 10.8905 5.95399C10.9995 5.74008 10.9995 5.46005 10.9995 4.9Z" stroke="#B42318" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    {languageData?.FEEDBACK_UNSATISFIED}
                                </button>
                            </div>
                      </div>
                    </div>
                    <div className="feedback-popup-footer a-flex a-justify-content-end a-padding-md-top">
                        <button className="aa_btn primaryBtn aa-widget-feedback-submit-btn" disabled>{languageData?.SUBMIT}</button>
                    </div>
                </div>
            </div>
        )
    }

    const SummaryPopupHTMLEle = (props: any) => {
        
        let {msgData} = props;
        const rootServiceInstance = hostInstance.rootService;
        let initPopup = msgData?.initPopup || false;        
        let submitEnabled = rootServiceInstance?.aaSettings?.summarization['localeData'][rootServiceInstance?.connectionDetails?.interactiveLanguage || 'en']?.canSubmit;
        const hideRegenerateButton = () => {
            return !rootServiceInstance.summaryInProgress && rootServiceInstance.currentGenIntSummaryCount < rootServiceInstance.maxIntSummaryCount && !rootServiceInstance.finalSummaryGenerated
        }
        
        return (
            <div className="summery-wrapper-container a-padding-xl" id="aa-summary-wrapper-container">
                <div className="summery-popup-data" id="aa-conv-summary">
                    <div className="title-block">
                        <svg width="19" height="14" viewBox="0 0 19 14" fill="none" >
                            <path d="M9.99979 5.81524V8.01866C9.56245 8.60838 8.98161 8.80996 8.40024 8.80996C7.3657 8.80996 6.64453 7.93073 6.64453 6.92499C6.64453 5.90316 7.3657 5.00732 8.40024 5.00732C8.98161 5.00732 9.56245 5.21212 9.99979 5.81524Z" fill="#111827" />
                            <path d="M16.4016 0.310059H4.49325C4.21767 0.309988 3.94477 0.36504 3.69014 0.47207C3.43552 0.579099 3.20415 0.73601 3.00926 0.93384C2.81437 1.13167 2.65978 1.36654 2.5543 1.62505C2.44882 1.88355 2.39453 2.16062 2.39453 2.44043V9.25632C3.97002 9.26274 5.2009 10.4831 5.2009 12.0474C5.20345 12.5621 5.06557 13.0674 4.80255 13.5074H16.4016C16.9579 13.507 17.4914 13.2824 17.8848 12.883C18.2782 12.4836 18.4994 11.9419 18.4998 11.3771V2.44257C18.5001 2.1626 18.4461 1.88532 18.3408 1.62657C18.2355 1.36782 18.081 1.13269 17.8861 0.934628C17.6913 0.736565 17.4598 0.579454 17.2051 0.472284C16.9504 0.365115 16.6773 0.309988 16.4016 0.310059ZM12.2015 10.4932H10.234V9.94594C9.71132 10.2921 9.0748 10.4932 8.3113 10.4932C6.44232 10.4932 4.92796 8.91285 4.92796 6.91516C4.92796 4.88858 6.44232 3.32104 8.3113 3.32104C9.07322 3.32104 9.71132 3.5222 10.234 3.86834V3.32104H12.2015V10.4932ZM15.9679 10.4932H14.0004V3.32104H15.9706L15.9679 10.4932Z" fill="#111827" />
                            <path d="M2.16101 10.5996C1.30956 10.5996 0.605469 11.2231 0.605469 12.0442C0.605469 12.884 1.30956 13.5075 2.16101 13.5075C3.03295 13.5075 3.73705 12.884 3.73705 12.0442C3.73705 11.2226 3.03295 10.5996 2.16101 10.5996Z" fill="#111827" />
                        </svg>
                        <h1>{languageData?.SUMMARY_TEXT}</h1>
                        <div className="ai-block">
                            <button type="button" className="close-summery aa-minimize-summary">
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path d="M2 5.83333H2.13333C3.25344 5.83333 3.81349 5.83333 4.24131 5.61535C4.61764 5.4236 4.9236 5.11764 5.11535 4.74131C5.33333 4.31349 5.33333 3.75344 5.33333 2.63333V2.5M2 11.1667H2.13333C3.25344 11.1667 3.81349 11.1667 4.24131 11.3847C4.61764 11.5764 4.9236 11.8824 5.11535 12.2587C5.33333 12.6865 5.33333 13.2466 5.33333 14.3667V14.5M10.6667 2.5V2.63333C10.6667 3.75344 10.6667 4.31349 10.8847 4.74131C11.0764 5.11764 11.3824 5.4236 11.7587 5.61535C12.1865 5.83333 12.7466 5.83333 13.8667 5.83333H14M10.6667 14.5V14.3667C10.6667 13.2466 10.6667 12.6865 10.8847 12.2587C11.0764 11.8824 11.3824 11.5764 11.7587 11.3847C12.1865 11.1667 12.7466 11.1667 13.8667 11.1667H14" stroke="#667085" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                            <button type="button" className="close-summery aa-close-summary-text">
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                                    <path d="M15 5.2002L5 15.2002M5 5.2002L15 15.2002" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className="summary-intent-block-data-accordion a-padding-smm">
                        <div className={`summary-intent-block-data-accordion-item aa-summary-accordion-interim ${rootServiceInstance?.generatedSummaries?.length > 0 ? '' : 'aa-hidden'}`}>
                            <button type="button" className="acc-summary-btn a-flex a-align-items-center a-gap-4 aa-previous-summary-btn" aria-expanded="false" aria-controls="collapseExample">
                                <div className="text-truncate aa-text-xs medium">{languageData?.PREV_SUMMARIES}</div>
                                <span className="aa-summary-count">{rootServiceInstance?.generatedSummaries?.length}</span>
                                <div className="summery-accordion-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 6L8 10L12 6" stroke="#344054" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </button>
                            <div className="acc-summary-content-collapse aa-summary-content-collapse aa-hidden">
                                {rootServiceInstance?.generatedSummaries?.map((item: any, index: number) => (
                                    item?.type != 'final' && (
                                        <div className="summery-accordion-content">
                                        <div className="summery-accordion-content-inner-sec">
                                            <div className="summery-accordion-content-inner-sec-item aa-text-xs" data-positionId={item.positionId} data-type={item.type}>{item.editedSummary ? item.editedSummary : item.summary}</div>
                                        </div>
                                        <div className={`summery-accordion-content-item-date-time aa-summary-content-feedback-wrapper aa-prev-summary-${index}`}>

                                        </div>
                                    </div>
                                    ) 
                                ))}
                            </div>
                        </div>
                        <div className={`summary-intent-block-data-accordion-item new-summary-intent aa-summary-content-area`}>
                            <div className="acc-summary-content-collapse">
                                <div className="text-block-summary aa-summary-text-input-wrapper">
                                <textarea className="input-control aa-summary-text-input aa-summary-text-input-new"
                                    id="summaryText" placeholder={'Type Summary...'} rows={4} cols={50} value=""></textarea>
                                <button className={`recylin-bin-btn aa-delete-summary-text`}>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M13.3333 4.99996V4.33329C13.3333 3.39987 13.3333 2.93316 13.1517 2.57664C12.9919 2.26304 12.7369 2.00807 12.4233 1.84828C12.0668 1.66663 11.6001 1.66663 10.6667 1.66663H9.33333C8.39991 1.66663 7.9332 1.66663 7.57668 1.84828C7.26308 2.00807 7.00811 2.26304 6.84832 2.57664C6.66667 2.93316 6.66667 3.39987 6.66667 4.33329V4.99996M8.33333 9.58329V13.75M11.6667 9.58329V13.75M2.5 4.99996H17.5M15.8333 4.99996V14.3333C15.8333 15.7334 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8211 14.4683 18.0608C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0608C5.06129 17.8211 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7334 4.16667 14.3333V4.99996" stroke="#D92D20" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="actions-footer">
                    <div className="footer-btns-left-sec">
                        {submitEnabled && (<button className={`aa_btn primaryBtn aa-summit-summary-text aa-summary-submit-btn`} disabled={initPopup} id="summarySubmit" >{languageData?.SUBMIT}</button>)}
                        <button className={`aa_btn aa-solidbtn aa-copy-summary-text aa-summary-copy-btn`} disabled={initPopup} id="summaryCopy" >{languageData?.COPY}</button>
                        <button
                            className={`aa_btn aa-solidbtn refresh-btn aa-summary-refresh-btn`}
                            disabled={!hideRegenerateButton()}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M7.12246 16.4733C9.12174 17.3603 11.503 17.3121 13.5421 16.1348C16.93 14.1788 18.0908 9.84667 16.1348 6.45876L15.9265 6.09792M3.86571 13.5422C1.9097 10.1543 3.07048 5.82219 6.45839 3.86618C8.49754 2.68888 10.8788 2.64071 12.878 3.52768M2.07812 13.6119L4.35483 14.2219L4.96488 11.9452M15.0358 8.05528L15.6459 5.77857L17.9226 6.38861" stroke="#344054" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    const submitSummaryResolution = () => {
        let editedSummaryText = (hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_EDITED_TEXT}`) as HTMLTextAreaElement);
        const summaryTextValue = editedSummaryText?.value || "";        
        const summaryId = editedSummaryText?.getAttribute('data-summaryId') || "";
        const positionId = editedSummaryText?.getAttribute('data-positionId') || "";
        const traceId = editedSummaryText?.getAttribute('data-traceId') || "";
        let connectionDetails = hostInstance.rootService.connectionDetails;
        if(positionId && summaryId){
            let submitSummaryRequestParams = {
                conversationId : connectionDetails?.conversationId,
                botId: connectionDetails?.botId,
                experience : connectionDetails?.experience,
                isExtAD : true,
                language : connectionDetails?.interactiveLanguage,
                positionId : positionId || '',
                summary : [
                  {
                      'summary_text' : summaryTextValue || '',
                      'summaryId' : summaryId || ''
                  }
                ],
                traceId : traceId
              };
            let generatedSummaryObj = rootServiceInstance.generatedSummaries?.find((item: any) => item.summaryId === summaryId);
            if(generatedSummaryObj){
                generatedSummaryObj.editedSummary = summaryTextValue;
            }
            hostInstance.socketConnection.emitEvents(EVENTS.submit_summary_request, submitSummaryRequestParams)
        }
        closeSummaryPopup(editedSummaryText);
    }

    const copySummaryResolution = () => {
        const summaryTextValue = (document.getElementById("summaryText") as HTMLTextAreaElement)?.value || "";
        navigator.clipboard.writeText(summaryTextValue).then(() => {
        }).catch(err => {
        });
    }

    const closeSummaryPopup = (editedSummaryText : any) => {
    
        let finalSummary = rootServiceInstance?.finalSummaryGenerated
        let summaryType = finalSummary ? 'final' : 'interim';
        // rootServiceInstance.isSummaryMinimized = false;
        const summaryTextValue = (document.getElementById("summaryText") as HTMLTextAreaElement)?.value || "";
        if(summaryTextValue && (summaryType == 'final' || finalSummary)){
            hostInstance.emit(INTERNAL_EVENTS.CONVERSATION_SUMMARY_IN_ASSIST, summaryTextValue);
        }
        hideSummary();

        if(!rootServiceInstance.finalSummaryGenerated){
            addToPreviouSummary(editedSummaryText,summaryType)
            showOrHideSummaryTextArea(false);
        }else{
            showOrHideSummaryTextArea(true);
        }
    }

    const addToPreviouSummary = (editedSummaryText : any, type : string) => {
        let positionId = editedSummaryText.getAttribute('data-positionId');
        if(positionId && type == 'interim' && rootServiceInstance?.generatedSummaries?.length > 0){
            let summaryContentCollapse = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_CONTENT_COLLAPSE}`);
            let summaryAccordionInterim = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_ACCORDION_INTERIM}`);
            let summaryContentArea = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_CONTENT_AREA}`);
            updateGeneratedSummariesCount();
            if(summaryContentCollapse && summaryAccordionInterim){
                let interimSummaries = rootServiceInstance?.generatedSummaries?.filter((summary: any) => summary.type === 'interim');
                let index = interimSummaries?.length - 1;                
                summaryAccordionInterim.classList.remove(classConstants.HIDE_ELEMENT);
                let summaryContent = getHTML(updatePreviousSummary, {summaryText : editedSummaryText.value, summaryIndex : index}, hostInstance);

                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, summaryContent, {
                    event: SDK_EVENTS.SUMMARY_PREVIOUS_TEMPLATE,
                    data : {summaryText : editedSummaryText.value, summaryIndex : index}
                });
    
                summaryContentCollapse?.append(summaryContent);

            }
            if(editedSummaryText){
                editedSummaryText.value = '';
            }
           summaryContentArea?.classList?.remove(classConstants.HIDE_ELEMENT);
        }
    }

    const deleteSummaryText = () => {
        setEditedSummaryText("");
        (document.getElementById("summaryText") as HTMLTextAreaElement).value = '';
    }

    const handleMinimizedIcon = ()=>{
        const summaryOverlayEle = document.getElementsByClassName(idMapConstants.SUMMARY_OVERLAY_BLOCK)[0];
        const minimizedIcon:any = getHTML(minimizedSummPreHTML,'',hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, minimizedIcon, {
            event: SDK_EVENTS.SUMMARY_PREVIOUS_TEMPLATE,
            data : {}
        });
        summaryOverlayEle.append(minimizedIcon)
        summaryOverlayEle.querySelector(`${classConstants.SUMMARY_ACTION_MINIMIZED}`)?.addEventListener('click',()=>{
            summaryOverlayEle.removeChild(minimizedIcon)
            showSummary();
        })
        return minimizedIcon
    }

    const minimizedSummPreHTML = ()=>{
        return (
            <div className="generate-summary-action-minimized aa-generate-summary-action-minimized" >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="svg-inner">
                <path d="M8 3C8.27614 3 8.5 2.77614 8.5 2.5C8.5 2.22386 8.27614 2 8 2C7.72386 2 7.5 2.22386 7.5 2.5C7.5 2.77614 7.72386 3 8 3Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 6.5C8.27614 6.5 8.5 6.27614 8.5 6C8.5 5.72386 8.27614 5.5 8 5.5C7.72386 5.5 7.5 5.72386 7.5 6C7.5 6.27614 7.72386 6.5 8 6.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 10C8.27614 10 8.5 9.77614 8.5 9.5C8.5 9.22386 8.27614 9 8 9C7.72386 9 7.5 9.22386 7.5 9.5C7.5 9.77614 7.72386 10 8 10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 3C4.77614 3 5 2.77614 5 2.5C5 2.22386 4.77614 2 4.5 2C4.22386 2 4 2.22386 4 2.5C4 2.77614 4.22386 3 4.5 3Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 6.5C4.77614 6.5 5 6.27614 5 6C5 5.72386 4.77614 5.5 4.5 5.5C4.22386 5.5 4 5.72386 4 6C4 6.27614 4.22386 6.5 4.5 6.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 10C4.77614 10 5 9.77614 5 9.5C5 9.22386 4.77614 9 4.5 9C4.22386 9 4 9.22386 4 9.5C4 9.77614 4.22386 10 4.5 10Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg width="19" height="14" viewBox="0 0 19 14" fill="none" >
                            <path d="M9.99979 5.81524V8.01866C9.56245 8.60838 8.98161 8.80996 8.40024 8.80996C7.3657 8.80996 6.64453 7.93073 6.64453 6.92499C6.64453 5.90316 7.3657 5.00732 8.40024 5.00732C8.98161 5.00732 9.56245 5.21212 9.99979 5.81524Z" fill="#111827" />
                            <path d="M16.4016 0.310059H4.49325C4.21767 0.309988 3.94477 0.36504 3.69014 0.47207C3.43552 0.579099 3.20415 0.73601 3.00926 0.93384C2.81437 1.13167 2.65978 1.36654 2.5543 1.62505C2.44882 1.88355 2.39453 2.16062 2.39453 2.44043V9.25632C3.97002 9.26274 5.2009 10.4831 5.2009 12.0474C5.20345 12.5621 5.06557 13.0674 4.80255 13.5074H16.4016C16.9579 13.507 17.4914 13.2824 17.8848 12.883C18.2782 12.4836 18.4994 11.9419 18.4998 11.3771V2.44257C18.5001 2.1626 18.4461 1.88532 18.3408 1.62657C18.2355 1.36782 18.081 1.13269 17.8861 0.934628C17.6913 0.736565 17.4598 0.579454 17.2051 0.472284C16.9504 0.365115 16.6773 0.309988 16.4016 0.310059ZM12.2015 10.4932H10.234V9.94594C9.71132 10.2921 9.0748 10.4932 8.3113 10.4932C6.44232 10.4932 4.92796 8.91285 4.92796 6.91516C4.92796 4.88858 6.44232 3.32104 8.3113 3.32104C9.07322 3.32104 9.71132 3.5222 10.234 3.86834V3.32104H12.2015V10.4932ZM15.9679 10.4932H14.0004V3.32104H15.9706L15.9679 10.4932Z" fill="#111827" />
                            <path d="M2.16101 10.5996C1.30956 10.5996 0.605469 11.2231 0.605469 12.0442C0.605469 12.884 1.30956 13.5075 2.16101 13.5075C3.03295 13.5075 3.73705 12.884 3.73705 12.0442C3.73705 11.2226 3.03295 10.5996 2.16101 10.5996Z" fill="#111827" />
                        </svg>
                {/* <i className="krIocnsFont-Aimark"></i> */}
                <span className="status-summary-indicator"></span>
            </div>
        )
    }

    const dragIntermSumm = () => {

        const miniIcon = handleMinimizedIcon();
        const summaryAction = miniIcon as HTMLElement;
        const container = hostInstance?.chatEle?.querySelector(".section-agent-aa-wrapper"); // Replace with actual container class

        if (summaryAction && container) {
            // Set default position using bottom and right within container
            summaryAction.style.position = 'absolute';
            summaryAction.style.bottom = '150px';
            summaryAction.style.right = '20px';
            summaryAction.style.zIndex = '999';

            let isDragging = false;
            let offsetX = 0, offsetY = 0;

            const stopDragging = () => {
                isDragging = false;
            };

            summaryAction.addEventListener('mousedown', (event: MouseEvent) => {
                isDragging = true;

                try {
                    // Get element and container bounds with safety checks
                    if (!summaryAction.isConnected || !container.isConnected) return;
                    
                    const rect = summaryAction.getBoundingClientRect();
                    const containerRect = container.getBoundingClientRect();

                    // Calculate offset from bottom-right within container
                    offsetX = containerRect.right - event.clientX;
                    offsetY = containerRect.bottom - event.clientY;
                } catch (error) {
                    console.warn('Drag initialization failed:', error);
                    isDragging = false;
                    return;
                }

                event.preventDefault();
            });

            document.addEventListener('mousemove', (event: MouseEvent) => {
                if (!isDragging) return;

                try {
                    // Safety checks before DOM measurements
                    if (!summaryAction.isConnected || !container.isConnected) {
                        isDragging = false;
                        return;
                    }

                    const containerRect = container.getBoundingClientRect();
                    const elementRect = summaryAction.getBoundingClientRect();

                    // Calculate new position relative to container
                    let right = containerRect.right - event.clientX - offsetX;
                    let bottom = containerRect.bottom - event.clientY - offsetY;

                    // Ensure it stays within container boundaries
                    right = Math.max(0, Math.min(right, containerRect.width - elementRect.width));
                    bottom = Math.max(0, Math.min(bottom, containerRect.height - elementRect.height));

                    // Apply new position
                    summaryAction.style.right = `${right}px`;
                    summaryAction.style.bottom = `${bottom}px`;
                } catch (error) {
                    console.warn('Drag movement failed:', error);
                    isDragging = false;
                }

                event.preventDefault();
            });

            document.addEventListener('mouseup', stopDragging);
            document.addEventListener('mouseleave', stopDragging);
            summaryAction.removeAttribute('draggable');
        }
    }

    const showSummary = () => {
        hostInstance?.chatEle?.querySelector?.(`#${idMapConstants.SUMMARY_WRAPPER}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
    }

    const showOrHideSummaryTextArea = (show : boolean) => {
        let summaryContentArea = (hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_CONTENT_AREA}`) as HTMLTextAreaElement);
        let summaryTextArea = hostInstance?.chatEle?.querySelector('#summaryText');
        let actionsFooter = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_ACTION_FOOTER}`);
        let formFeedback = actionsFooter?.querySelector?.(`${classConstants.FORM_FEEDBACK}`);
        if(summaryContentArea && !show){
            formFeedback?.classList?.add(classConstants.HIDE_ELEMENT);
            summaryContentArea?.classList?.add(classConstants.HIDE_ELEMENT);
            if(summaryTextArea){
                summaryTextArea.value = '';
                summaryTextArea.textContent = '';
            }
        }else{
            formFeedback?.classList?.remove(classConstants.HIDE_ELEMENT);
            summaryContentArea?.classList?.remove(classConstants.HIDE_ELEMENT);
        }
    }

    const removeFeedbackSummary = (actionsFooter : any) => {
       let feedbackWrapper = actionsFooter?.querySelector?.(`${classConstants.FORM_FEEDBACK}`);
       if(feedbackWrapper){
        feedbackWrapper?.remove();
       }
    }

    const addFeedbackToSummary = (initiateFeedback : boolean = true) => {        
        let summaryWrapper : any = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        let summaryTextArea = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_EDITED_TEXT}`) as HTMLTextAreaElement;
        const summaryFooter : any = summaryWrapper?.querySelector(`.actions-footer`);
        let feedbackWrapper = summaryFooter?.querySelector?.(`${classConstants.FORM_FEEDBACK}`);
        if(!feedbackWrapper && !summaryTextArea?.classList?.contains(classConstants.HIDE_ELEMENT)){
            let positionId : any = summaryTextArea?.getAttribute('data-positionId');
            let summaryId : any = summaryTextArea?.getAttribute('data-summaryId');
            let traceId : any = summaryTextArea?.getAttribute('data-traceId');
            if(rootServiceInstance.aaSettings?.feedback[FeebackConst.SUMMARY]?.isEnabled){
                let feedbackWrapperTemplate : any = getHTML(FeedbackWrapperInsideDialog, {dialog : {dialogId : positionId, summaryId, traceId}}, hostInstance);
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackWrapperTemplate, {
                    event: SDK_EVENTS.SUMMARY_FEEDBACK_TEMPLATE,
                    data : {dialog : {dialogId : positionId, summaryId, traceId}}
                });
                if(initiateFeedback){
                    hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackWrapperTemplate, {
                        event: SDK_EVENTS.FEEDBACK_WRAPER_TEMPLATE,
                        data : {dialog : {dialogId : positionId}}
                    });
                    summaryFooter.append(feedbackWrapperTemplate);  
                }
            }
        }
    }

    const updateFeedbackForMainSummary = () => {
        let summaryWrapper : any = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        let summaryFooter : any = summaryWrapper?.querySelector(`.actions-footer`);
        let feedbackWrapper = summaryFooter?.querySelector?.(`${classConstants.FORM_FEEDBACK}`);
        let summaryTextArea = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_EDITED_TEXT}`) as HTMLTextAreaElement;
        if(feedbackWrapper && summaryTextArea){
            let positionId : any = summaryTextArea?.getAttribute('data-positionId');
            let summaryId : any = summaryTextArea?.getAttribute('data-summaryId');
            let traceId : any = summaryTextArea?.getAttribute('data-traceId');
            let feedbackData = rootServiceInstance.generatedSummaries.find((item : any) => item.positionId === positionId)?.summaryFeedbackData || {positionId : positionId, summaryId, traceId};    
            removeExistingFeedback(summaryFooter, positionId);        
            rootServiceInstance.handleFeedbackType({dialogId : positionId, feedbackData : rootServiceInstance?.prepareFeedbackForSummary(feedbackData)}, summaryFooter, FeebackConst.SUMMARY, hostInstance);
        } 
    }

    const removeExistingFeedback = (summaryFooter : any, positionId : any) => {
        const feedbackHelpfulSection = summaryFooter?.querySelector?.(`.form-feedback-div`);
        const feedbackWrapper = summaryFooter?.querySelector?.(`.improve-feedback-block`);
        feedbackHelpfulSection && feedbackHelpfulSection?.remove();
        feedbackWrapper && feedbackWrapper?.remove();
    }

    const updateSummaryFeedback = (wrapper : any, positionId : any, summaryId : any, traceId : any, exeStartTime : any) => {        
        if(rootServiceInstance.aaSettings?.feedback[FeebackConst.SUMMARY]?.isEnabled){
            let feedbackWrapperTemplate : any = getHTML(FeedbackWrapperInsideDialog, {dialog : {dialogId : positionId, summaryId, traceId, exeStartTime}}, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, feedbackWrapperTemplate, {
                event: SDK_EVENTS.FEEDBACK_WRAPER_TEMPLATE,
                data : {dialog : {dialogId : positionId}}
            });
            
            wrapper.append(feedbackWrapperTemplate);
            let feedbackData = rootServiceInstance.generatedSummaries.find((item : any) => item.positionId === positionId)?.summaryFeedbackData || {positionId : positionId, summaryId, traceId};            
            rootServiceInstance.handleFeedbackType({dialogId : positionId, feedbackData : rootServiceInstance?.prepareFeedbackForSummary(feedbackData)}, wrapper, FeebackConst.SUMMARY, hostInstance);
        }
    }
    
    const regenerateSummary = () => {
        let editedSummaryText = (hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_EDITED_TEXT}`) as HTMLTextAreaElement);
        showOrHideSummaryTextArea(true);
        addToPreviouSummary(editedSummaryText, 'interim');
        generateSummary({}, true, true);
        updateGeneratedSummariesCount();
    }

    const addOrRemoveLoaderToSummary = (flag : boolean) => {
        let summaryOverlayEle = hostInstance?.chatEle?.querySelector?.(`#${idMapConstants.SUMMARY_WRAPPER}`);
        if(flag && summaryOverlayEle){
            hostInstance.renderIndividualLoader(summaryOverlayEle);
        }else if(!flag && summaryOverlayEle){
            hostInstance.removeIndividualLoader(summaryOverlayEle);
        }
    }

    const addSummaryToList = (respData : any) => {        
        if(respData?.summaryText){
            let positionId = respData?.positionId;
            let inx = rootServiceInstance.generatedSummaries.findIndex((item : any) => item.positionId === positionId);
            if(inx === -1 && positionId){
                let data : any = {
                    summary : [respData.summaryText],
                    editedSummary : respData.summaryText,
                    positionId : positionId,
                    type : respData?.type || 'interim',
                    traceId : respData?.traceId,
                    summaryId : respData?.summaryId,
                    exeStartTime : respData?.exeStartTime
                }
                rootServiceInstance.generatedSummaries.push(JSON.parse(JSON.stringify(data)));
            }
        }
        if(respData?.type === 'final'){
            let summaryContentArea = hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_CONTENT_AREA}`);
            let editedSummaryText = (hostInstance?.chatEle?.querySelector?.(`${classConstants.SUMMARY_EDITED_TEXT}`) as HTMLTextAreaElement);
            if(!summaryContentArea?.classList?.contains(classConstants.HIDE_ELEMENT) && editedSummaryText){
                addToPreviouSummary(editedSummaryText, 'interim');
                // addFeedbackToSummary(false);
            }   
        }
    }
    
    
    const updateGeneratedSummariesCount = () => {
        //generatedSummaries Count update.
        
        let generatedSummariesCount = rootServiceInstance.generatedSummaries?.filter((item : any) => item.type !== 'final')?.length;
        let summaryCountEle = hostInstance.chatEle.querySelector(`${classConstants.SUMMARY_COUNT}`);
        
        if(summaryCountEle){
            summaryCountEle.textContent = generatedSummariesCount;
        }
    }

    const generateSummary = (e : any, interim = false, regenerate = false) => {
        let summaryWrapper = hostInstance?.chatEle?.querySelector(`#${idMapConstants.SUMMARY_WRAPPER}`);
        let summaryClassList = summaryWrapper?.classList;
        if((!summaryClassList ||summaryClassList?.contains(classConstants.HIDE_ELEMENT)) && (rootServiceInstance.finalSummaryGenerated || hostInstance.localStorageService.getFinalSummaryGenerated())){
           rootServiceInstance.fetchSummaries(hostInstance);
           return;
        }
        addOrRemoveLoaderToSummary(true);
        let connectionDetails = hostInstance?.rootService?.connectionDetails;
        const conversationId = connectionDetails.conversationId;
          if (hostInstance.localStorageService.getConvObjFromLS()) {
            let request_resolution_comments : any = {
              userId: '',
              conversationId,
              botId: connectionDetails.botId,
              sessionId: KoreGenerateuuidPipe(),
              chatHistory: hostInstance?.rootService?.connectionDetails?.chatHistory,
              participant : rootServiceInstance?.internalTransferData?.participant || {},
              interimSummary: !!rootServiceInstance?.interimSummary,
            };
            request_resolution_comments['type'] = interim ? 'interim' : 'final';
            if(!interim){
              rootServiceInstance.finalSummaryGenerated = true;
            }
           
            if(summaryClassList?.contains(classConstants.HIDE_ELEMENT)){
                hostInstance.setSummaryPopup({initPopup : true});
            }
            request_resolution_comments['model'] = rootServiceInstance.aaSettings?.summarization['localeData'][connectionDetails.interactiveLanguage || 'en']?.model;
            hostInstance.socketConnection.emitEvents(EVENTS.request_resolution_comments, request_resolution_comments);
            if(!interim){
                request_resolution_comments['crId'] = 'custom';
                request_resolution_comments['cTPositionId'] = rootServiceInstance.currentCustomTabAutomationId;
                hostInstance.socketConnection.emitEvents(EVENTS.end_of_conversation, request_resolution_comments);
            }
            disableOrEnableSummaryRefreshButton(false);
          }
    }

    return (
        <Fragment>
            {showWidget && (
                <ErrorBoundary hostInstance={hostInstance}>
                    <div className={chatContainerClass} aria-label='agent-window-section'>
                        <section className="section-agent-aa-wrapper">
                            <header className="aa-header"></header>
                            <section className="body-container-aa">
                                {/* <div className={assistTabActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                    <Assist hostInstance={hostInstance} />
                                </div>
                                <div className={searchTabActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                    <Search hostInstance={hostInstance} />
                                </div>
                                {<div className={transcriptTabActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                    <Transcript hostInstance={hostInstance} />
                                </div>}
                                <div className={mybotTabActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                    <MyBot hostInstance={hostInstance} />
                                </div>
                                {rootServiceInstance?.aaSettings?.isAgentPlaybookEnabled && (<div className={playbookTabActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                    <Playbook hostInstance={hostInstance} />
                                </div>)} */}
                                {tabsNTitles.map((tab: any) => {
                                    if (!tab.isEnabled) return null;
                                    if (tab.type === 'cl' && !rootServiceInstance?.aaSettings?.isAgentPlaybookEnabled) return null;
                                    if (tab.type === 'cst' && !rootServiceInstance?.customTabPrefsObj?.customTabEnabled){ 
                                        setAssistTabActive(true);
                                    }
                                    
                                    const TabComponent = tabComponents[tab.type];
                                    const isActive = tabActiveStates[tab.type];

                                    return TabComponent ? (
                                        <div key={tab.type} className={isActive ? 'animate-compo-slide-up-wrapper' : 'aa-hidden'}>
                                            <TabComponent hostInstance={hostInstance} />
                                        </div>
                                    ) : null;
                                })}
                            </section>
                            <footer className="aa-footer">
                            </footer>
                            {rootServiceInstance?.aaSettings?.isAgentCoachingEnabled && (<div className="nudges-wrapper-fixed aa-nudges-wrapper-fixed">
                                <div className="nudges-template-data aa-nudges-template-data">
                                </div>
                            </div>)}

                            {rootServiceInstance?.aaSettings?.isAgentCoachingEnabled && (<div className="hints-wrapper-fixed aa-hints-wrapper-fixed">
                                <div className="hints-template-data aa-hints-template-data">
                                </div>
                            </div>)}

                        </section>
                        {/* AgenticCoPilot renders in parallel and listens to events independently */}
                        <div className='p-none visibility-hidden agentic-co-pilot-wrapper'>
                            <AgenticCoPilot hostInstance={hostInstance} />
                        </div>
                        {/* interputions error Code */}
                    </div>
                                        
                </ErrorBoundary>
            )}
            {!showWidget && (
                 <div className={chatContainerClass} aria-label='agent-window-section'>
                     <section className="section-agent-aa-wrapper">
                        <div class="widgets-disabled-card-wrapper">
                            <div class="widgets-info-disabled-content">
                                <div class="icon_block">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M8 6.00015V8.66682M8 11.3335H8.00667M7.07688 2.59464L1.59362 12.0657C1.28948 12.591 1.13742 12.8537 1.15989 13.0693C1.1795 13.2573 1.27801 13.4282 1.43091 13.5394C1.60622 13.6668 1.90973 13.6668 2.51674 13.6668H13.4833C14.0903 13.6668 14.3938 13.6668 14.5691 13.5394C14.722 13.4282 14.8205 13.2573 14.8401 13.0693C14.8626 12.8537 14.7105 12.591 14.4064 12.0657L8.92312 2.59463C8.62007 2.07119 8.46855 1.80947 8.27087 1.72157C8.09843 1.64489 7.90157 1.64489 7.72913 1.72157C7.53145 1.80947 7.37992 2.07119 7.07688 2.59464Z" stroke="#F79009" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                </div>
                                <div class="content-info-widget">
                                    <h1>{languageData?.WIDGET_DISABLED}</h1>
                                    <p>{languageData?.AI_SETTINGS_DISABLED}</p>
                                </div>
                            </div>
                        </div>
                     </section>
                 </div>
            )}
            
        </Fragment>
    );
}
